function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this,
        args = arguments,
        later = function () {
          (timeout = null), immediate || func.apply(context, args);
        },
        callNow = immediate && !timeout;
      clearTimeout(timeout),
        (timeout = setTimeout(later, wait)),
        callNow && func.apply(context, args);
    };
  }
  function getRandomInt(minimum, maximum) {
    return Math.floor(Math.random() * (maximum - minimum + 1) + minimum);
  }
  function closeModal(event, modal = !1) {
    modal ||
      (modal =
        event.currentTarget.closest("[data-bstr-modal]") ||
        event.currentTarget.closest(".modal")),
      (modal.style.display = "none");
  }
  const isUndefined = (e) => typeof e > "u";
  Element.prototype.closestEl = function (e) {
    for (var t = this.parentElement; t; ) {
      if (t.matches(e)) return t;
      var r = t.querySelectorAll(e);
      for (let i = 0, mi = r.length; i < mi; ++i)
        if (r[i] != null && r[i] != this) return r[i];
      t = t.parentElement;
    }
    return null;
  };
  const BstrDummyClass = new Proxy(new (class {})(), {
      get(target, name) {
        return () => {};
      },
    }),
    __bstrInitClass = (cls, ...args) => {
      try {
        return new cls(...args);
      } catch (err) {
        console.debug("[Booster Class Init] ", err);
      }
    };
  class BstrStore {
    constructor() {}
    get(key, def = !1, parse = !0) {
      const value = localStorage.getItem(key);
      if (!value) return def;
      if (!parse) return value;
      try {
        const json = JSON.parse(value);
        return typeof json.data == null ||
          typeof json.exp == null ||
          json.storeRef !== "bstr"
          ? json
          : json.exp && json.exp < Date.now()
          ? (localStorage.removeItem(key), def)
          : json.data;
      } catch {
        return def;
      }
    }
    set(key, value, exp = !1) {
      const expiration = exp && !isNaN(exp) ? Date.now() + exp * 6e4 : !1,
        dataToStore = { data: value, storeRef: "bstr", exp: expiration };
      return localStorage.setItem(key, JSON.stringify(dataToStore)), !0;
    }
  }
  class BstrAsync {
    constructor({ events: events2 }) {
      this.events = events2;
    }
    async load({ url, section = !1, selector = "body", json = !1 }) {
      section && url.searchParams.set("section_id", section);
      let r = await fetch(url.toString());
      if (!r.ok) return {};
      try {
        let raw = await r.text(),
          dom = new DOMParser().parseFromString(raw, "text/html");
        if (!json)
          return { html: dom.querySelector(selector).innerHTML, parser: dom };
        try {
          return {
            html: dom.querySelector(selector).innerHTML,
            parser: dom,
            json: JSON.parse(dom.querySelector(json).innerText),
          };
        } catch (err) {
          return (
            console.debug(err),
            { html: dom.querySelector(selector).innerHTML, parser: dom, json: !1 }
          );
        }
      } catch (err) {
        return console.debug(err), {};
      }
    }
    async getUpsell(product) {
      let { html } = await this.load({
        url: new URL(window.location.origin + product),
        section: "api__upsell",
        selector: ".shopify-section",
      });
      return html;
    }
  }
  class BstrCart {
    constructor({ events: events2, basync }) {
      (this.events = events2),
        (this.basync = basync),
        (this.queue = []),
        (this.awaitingSuccess = []),
        (this.listeners = []),
        (this.minicart = { lastUpdate: 0 }),
        (this.cartSuccessConfig = { action: _settings.cartAction }),
        (this.cartSuccessInfoTemplate =
          (document.querySelector(".add-to-cart__success--single-current") &&
            document.querySelector(".add-to-cart__success--single-current")
              .innerHTML) ||
          !1);
      let carts = document.querySelectorAll("[data-cart-container]");
      for (let i = 0, maxi = carts.length; i < maxi; ++i)
        this.addListener(carts[i]);
      this.dispatchListeners(), this.bindXHRFetch();
    }
    bindXHRFetch() {
      const self2 = this,
        open = window.XMLHttpRequest.prototype.open;
      function openReplacement() {
        return (
          this.addEventListener("load", function () {
            try {
              let url = new URL(this._url);
              url.origin == window.location.origin &&
                [
                  `${window.Shopify.routes.root}cart/add.js`,
                  `${window.Shopify.routes.root}cart/update.js`,
                  `${window.Shopify.routes.root}cart/change.js`,
                  `${window.Shopify.routes.root}cart/clear.js`,
                  `${window.Shopify.routes.root}cart/add`,
                ].includes(url.pathname) &&
                self2.dispatchListeners({ change: !0 });
            } catch {
              try {
                [
                  `${window.Shopify.routes.root}cart/add.js`,
                  `${window.Shopify.routes.root}cart/update.js`,
                  `${window.Shopify.routes.root}cart/change.js`,
                  `${window.Shopify.routes.root}cart/clear.js`,
                  `${window.Shopify.routes.root}cart/add`,
                ].includes(this._url) && self2.dispatchListeners({ change: !0 });
              } catch {
                console.log("[BOOSTER THEME] Invalid URL format caught in XHR.");
              }
            }
          }),
          open.apply(this, arguments)
        );
      }
      (window.XMLHttpRequest.prototype.open = openReplacement),
        (function (ns, fetch2) {
          typeof fetch2 == "function" &&
            (ns.fetch = function () {
              const response = fetch2.apply(this, arguments);
              return (
                response.then((res) => {
                  try {
                    let url = new URL(res.url);
                    url.origin == window.location.origin &&
                      [
                        `${window.Shopify.routes.root}cart/add.js`,
                        `${window.Shopify.routes.root}cart/update.js`,
                        `${window.Shopify.routes.root}cart/change.js`,
                        `${window.Shopify.routes.root}cart/clear.js`,
                        `${window.Shopify.routes.root}cart/add`,
                      ].includes(url.pathname) &&
                      self2.dispatchListeners({ change: !0 });
                  } catch {
                    console.log(
                      "[BOOSTER THEME] Invalid URL format caught in fetch."
                    );
                  }
                }),
                response
              );
            });
        })(window, window.fetch),
        window.addEventListener("storage", (e) => {
          e.key == "bstr:cart:update" &&
            bstore.get("bstr:cart:update", 0) > self2.minicart.lastUpdate &&
            this.dispatchListeners();
        });
    }
    open() {
      if (document.querySelectorAll("[data-minicart-input]:checked").length)
        return;
      let mi = document.querySelectorAll("[data-minicart-input]");
      for (let m of mi) {
        let l = m.closestEl(".minicart__label");
        if (l && l.clientHeight > 0 && l.clientWidth > 0) return (m.checked = !0);
      }
    }
    close() {
      let checked = document.querySelectorAll("[data-minicart-input]:checked");
      for (let c of checked) c.checked = !1;
    }
    async clear() {
      (await fetch(`${window.Shopify.routes.root}cart/clear.js`)).ok &&
        this.events.trigger("booster:cart:clear");
    }
    addListener(target, data) {
      let settingsData = target.dataset.cartSettings.split(","),
        settings = {};
      for (let i = 0, maxi = settingsData.length; i < maxi; ++i) {
        let key = settingsData[i];
        settings[key] = target.querySelector(`[data-${key}]`);
      }
      this.listeners.push({ target, settings });
    }
    minicartHandler(time) {
      for (let i = 0, maxi = this.listeners.length; i < maxi; ++i) {
        let target = this.listeners[i],
          keys = Object.keys(target.settings);
        for (let j = 0, maxj = keys.length; j < maxj; ++j) {
          let key = keys[j];
          if (
            target.settings[key] &&
            !(target.settings[key].dataset.lastUpdate > time) &&
            !(typeof events < "u" && events.indexOf(key) == -1)
          ) {
            switch (key) {
              case "count":
                target.settings[key].innerText = this.minicart.data.item_count;
                break;
              case "product-list":
                target.settings[key].innerHTML = this.minicart.data.html;
                break;
              case "total":
                target.settings[key].innerText = this.minicart.data.total;
                break;
            }
            target.settings[key].dataset.lastUpdate = time;
          }
        }
      }
    }
      async dispatchListeners({change = false} = {}){
          let self = this;
          let time = Date.now();
  
          if(time > self.minicart.lastUpdate){
            console.log(window.location.origin)
              let cartData = await (
                await fetch(
                  `${window.location.origin}/?section_id=api__minicart`,
                  {
                    headers: {
                      Pragma: "no-cache",
                      "Cache-Control": "no-cache, no-store, must-revalidate",
                      Expires: 0,
                    },
                  }
                )
              ).text();
  
              // Create a DOM from the HTML string
              const parser = new DOMParser();
              const doc = parser.parseFromString(cartData, "text/html");
  
              // Find the <script> containing "cartItems"
              const script = doc.querySelector("#miniCartData");
              const jsonScript = script.textContent; 
  
              
              let div = document.createElement('div')
              div.innerHTML = cartData
              this.minicart = {lastUpdate: time, data: JSON.parse(jsonScript)};
              this.minicart.data.items = JSON.parse(this.minicart.data.items);
              this.events.trigger('booster:cart:update', this.minicart, true)
          }
  
          this.minicartHandler(time);
          if(change) localStorage.setItem('bstr:cart:update', time)
          this.events.trigger('booster:content:update', {trigger: 'minicart'})
  
          while(this.awaitingSuccess.length){
              this.success(this.awaitingSuccess.pop());
          }
      }
    quantityHandler(event, incr, updateCart = !0) {
      event.preventDefault();
      let qtyInput = event.target.parentElement.querySelector("[data-qty-input]");
      if (!qtyInput) return !1;
      if (incr) {
        qtyInput.value = (parseInt(qtyInput.value) || 0) + 1;
      } else {
        if (
          parseInt(qtyInput.value) <= 0 ||
          (!updateCart && parseInt(qtyInput.value) == 1)
        )
          return !1;
        qtyInput.value = (parseInt(qtyInput.value) || 1) - 1;
      }
      return updateCart ? qtyInput.onchange({ target: qtyInput }) : !0;
    }
    getCartQuantityForVariant(variantId) {
      let items = this.minicart && this.minicart.data && this.minicart.data.items,
        inCart = 0;
      if (!items || !variantId) return 0;
      if (Array.isArray(items)) {
        for (let i = 0; i < items.length; ++i) {
          if (
            String(items[i].id) === String(variantId) ||
            String(items[i].variant_id) === String(variantId)
          )
            inCart += parseInt(items[i].quantity) || 0;
        }
      } else if (items[variantId]) {
        inCart = parseInt(items[variantId].quantity) || 0;
      }
      return inCart;
    }
    exceedsStockLimit(form) {
      if (!form) return !1;
      let qtyInput =
          form.querySelector("[data-qty-input]") ||
          form.querySelector(".quantity--input__input") ||
          form.querySelector('[name="quantity"]'),
        idInput = form.querySelector('[name="id"]');
      if (!qtyInput || !idInput) return !1;
      let max = parseInt(qtyInput.max),
        addQty = parseInt(qtyInput.value) || 1,
        inCart = this.getCartQuantityForVariant(idInput.value);
      return !isNaN(max) && inCart + addQty > max;
    }
    addToQueue(data) {
      this.queue.push(data), !(this.queue.length > 1) && this.checkQueue();
    }
    addToCartIU() {
      let selected = document.querySelectorAll(
          "input.inline-upsell__toggle:checked"
        ),
        data = { items: [] };
      for (let i = 0, maxi = selected.length; i < maxi; ++i) {
        let id = document.getElementById(selected[i].dataset.for).value;
        data.items.push({ quantity: 1, id });
      }
      this.addToCartJSON(!1, data);
    }
    addToCart(event = !1, form = !1) {
      if (!event && !form) return;
      let target = !1;
      event &&
        ((target = event.currentTarget),
        event.preventDefault(),
        event.stopImmediatePropagation()),
        form || (form = target.closest("form"));
      if (this.exceedsStockLimit(form))
        return this.error("Die gewünschte Menge ist nicht verfügbar.");
      target &&
        ((target.disabled = !0),
        (target.querySelector("[data-button-text]").innerText =
          _bstrLocale.buttons.adding));
      let { prevent } = this.events.trigger("booster:cart:b*add", {
        form,
        target,
      });
      if (prevent) {
        target &&
          ((target.disabled = !1),
          (target.querySelector("[data-button-text]").innerText =
            target.dataset.originalText));
        return;
      }
      this.addToQueue({ form, target });
    }
    addToCartJSON(event = !1, json = { items: [] }) {
      let target = !1;
      event && (target = event.currentTarget),
        target &&
          ((target.disabled = !0),
          (target.querySelector("[data-button-text]").innerText =
            _bstrLocale.buttons.adding));
      let { prevent } = this.events.trigger("booster:cart:b*add", {
        json,
        target,
      });
      if (prevent) {
        target &&
          ((target.disabled = !1),
          (target.querySelector("[data-button-text]").innerText =
            target.dataset.originalText));
        return;
      }
      this.addToQueue({ target, json });
    }
    async removeFromCart(target = !1, id) {
      let mentry = target ? target.closest(".minicart__entry") : !1;
      target && (target.disabled = !0), mentry && (mentry.style.opacity = "0.5");
      let res = await (
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ quantity: 0, id }),
        })
      ).json();
      return !isUndefined(res.status) && res.status != "success"
        ? (target && (target.disabled = !1),
          mentry && (mentry.style.opacity = "1"),
          this.error(res))
        : !0;
    }
  
      updateQuantityDebounced = debounce(function (event) {
          this.updateQuantity(event);
      }, 300);
  
  
  
    async updateQuantity(event, variant, quantity, forced = !1) {
      let { target } = event;
      forced || ((variant = target.dataset.variantId), (quantity = target.value));
      const previousValue = target.dataset.lastQty || target.value;
      let res = await (
        await fetch(`${window.Shopify.routes.root}cart/change.js`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ quantity, id: variant }),
        })
      ).json();
      if (!isUndefined(res.status) && res.status != "success") {
        target.value = previousValue;
        return this.error(res);
      }
      target.dataset.lastQty = String(quantity);
    }
    checkQueue() {
      this.queue.length && this.processQueue(this.queue.shift());
    }
    async processQueue(data) {
      let { target, form, json } = data,
        fconfig = form
          ? {
              method: "POST",
              body: new URLSearchParams(new FormData(form)),
              headers: { "Content-Type": "multipart/form-data" },
            }
          : {
              method: "POST",
              body: JSON.stringify(json),
              headers: { "Content-Type": "application/json" },
            },
        res = await (
          await fetch(`${window.Shopify.routes.root}cart/add.js`, fconfig)
        ).json();
      target &&
        ((target.disabled = !1),
        (target.querySelector("[data-button-text]").innerText =
          target.dataset.originalText)),
        (window.dataLayer = window.dataLayer || []),
        window.dataLayer.push({
          event: "Add To Cart",
          items: [
            {
              id: res.id,
              name: res.title,
              brand: res.vendor,
              price: res.price * 0.01,
              variant: res.variant_title,
            },
          ],
        }),
        typeof res.status < "u" && res.status != "success"
          ? this.error(res)
          : this.awaitingSuccess.push(res),
        this.checkQueue();
    }
    async renderModal(item, render_upsell = !1) {
      if (
        this.events.trigger("booster:cart:b*modal", {
          item,
          cart: this.minicart,
          will_upsell: render_upsell,
        }).prevent
      )
        return;
      let container = document.getElementById("checkout--success"),
        modal = container.closest(".modal"),
        image = item.image,
        title = item.product_title,
        variant = "",
        total = this.minicart.data.total,
        itemCountInt = this.minicart.data.item_count,
        itemCount = itemCountInt + " item" + (itemCountInt > 1 ? "s" : "");
      item.product_has_only_default_variant || (variant = item.variant_title);
      let productInfo = container.querySelector(".add-to-cart__success--single");
      const $pi = (q) => productInfo.querySelector(q);
      let imgc = $pi(".add-to-cart__success--single-img");
      image != null
        ? ((imgc.src = image), (imgc.style.display = "block"))
        : (imgc.style.display = "none"),
        ($pi(".add-to-cart__success--single-title").innerText = title),
        ($pi(".add-to-cart__success--single-variation").innerText = variant);
      let template = this.cartSuccessInfoTemplate
        .replace("%total%", total)
        .replace("%itemCount%", itemCount);
      $pi(".add-to-cart__success--single-current").innerHTML = template;
      let prevent_upsell = this.events.trigger("booster:cart:b*upsell", {
        item,
        cart: this.minicart,
      });
      if (render_upsell && !prevent_upsell.prevent) {
        let upsell = await this.basync.getUpsell(item.url),
          upsellContainer = container.querySelector(
            ".add-to-cart__success--upsell"
          );
        if (((upsellContainer.style.display = "none"), upsell.trim() != "")) {
          let modal2 = document.getElementById("quickbuy__modal");
          modal2 && (modal2.style.display = "none"),
            (upsellContainer.innerHTML = upsell),
            (upsellContainer.style.display = "flex"),
            this.events.trigger("booster:cart:upsell", {
              html: upsellContainer,
              items: !1,
              item,
              cart: this.minicart,
            });
        }
      }
      (modal.style.display = "block"),
        this.events.trigger("booster:content:update", { trigger: "upsell" });
    }
    success(data) {
      let config = this.cartSuccessConfig,
        item = (data.items && data.items[0]) || data;
      if (
        (this.events.trigger("booster:cart:add", { item }),
        config.action == "cart")
      )
        return (window.location = `${window.Shopify.routes.root}cart`);
      if (config.action == "checkout")
        return (window.location = `${window.Shopify.routes.root}checkout`);
      if (config.action == "message")
        return this.events.trigger("booster:notify", {
          type: "success",
          message: "Product added to cart successfully.",
        });
      if (config.action == "minicart") return this.open();
      this.renderModal(item, config.action == "upsell");
    }
    error(data) {
      console.error(`Error trying to add product:\n  `, data);
      let message = data;
      if (data && typeof data == "object")
        message = data.description || data.message || JSON.stringify(data);
      if (typeof message == "string") {
        let lower = message.toLowerCase();
        (lower.includes("no more items in stock") ||
          lower.includes("not enough") ||
          lower.includes("sold out") ||
          lower.includes("inventory") ||
          lower.includes("stock")) &&
          (message = "Die gewünschte Menge ist nicht verfügbar.");
      }
      return this.events.trigger("booster:notify", {
        type: "error",
        message,
      });
    }
  }
  class BstrCurrency {
    constructor({ events: events2 }) {
      (this.moneyFormats = {
        USD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} USD",
        },
        EUR: {
          money_format: "&euro;{{amount}}",
          money_with_currency_format: "&euro;{{amount}} EUR",
        },
        GBP: {
          money_format: "&pound;{{amount}}",
          money_with_currency_format: "&pound;{{amount}} GBP",
        },
        CAD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} CAD",
        },
        ALL: {
          money_format: "Lek {{amount}}",
          money_with_currency_format: "Lek {{amount}} ALL",
        },
        DZD: {
          money_format: "DA {{amount}}",
          money_with_currency_format: "DA {{amount}} DZD",
        },
        AFN: {
          money_format: "&#65;&#102; {{amount}}",
          money_with_currency_format: "&#65;&#102; {{amount}} AFN",
        },
        AOA: {
          money_format: "Kz{{amount}}",
          money_with_currency_format: "Kz{{amount}} AOA",
        },
        ARS: {
          money_format: "${{amount_with_comma_separator}}",
          money_with_currency_format: "${{amount_with_comma_separator}} ARS",
        },
        AMD: {
          money_format: "{{amount}} AMD",
          money_with_currency_format: "{{amount}} AMD",
        },
        AWG: {
          money_format: "Afl{{amount}}",
          money_with_currency_format: "Afl{{amount}} AWG",
        },
        AUD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} AUD",
        },
        BBD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} Bds",
        },
        AZN: {
          money_format: "m.{{amount}}",
          money_with_currency_format: "m.{{amount}} AZN",
        },
        BDT: {
          money_format: "Tk {{amount}}",
          money_with_currency_format: "Tk {{amount}} BDT",
        },
        BSD: {
          money_format: "BS${{amount}}",
          money_with_currency_format: "BS${{amount}} BSD",
        },
        BHD: {
          money_format: "{{amount}}0 BD",
          money_with_currency_format: "{{amount}}0 BHD",
        },
        BYN: {
          money_format: "Br {{amount}}",
          money_with_currency_format: "Br {{amount}} BYN",
        },
        BYR: {
          money_format: "Br {{amount}}",
          money_with_currency_format: "Br {{amount}} BYR",
        },
        BZD: {
          money_format: "BZ${{amount}}",
          money_with_currency_format: "BZ${{amount}} BZD",
        },
        BTN: {
          money_format: "Nu {{amount}}",
          money_with_currency_format: "Nu {{amount}} BTN",
        },
        BAM: {
          money_format: "KM {{amount_with_comma_separator}}",
          money_with_currency_format: "KM {{amount_with_comma_separator}} BAM",
        },
        BRL: {
          money_format: "R$ {{amount_with_comma_separator}}",
          money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL",
        },
        BOB: {
          money_format: "Bs{{amount_with_comma_separator}}",
          money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB",
        },
        BMD: {
          money_format: "&#36; {{amount}}",
          money_with_currency_format: "&#36; {{amount}} BMD",
        },
        BIF: {
          money_format: "&#70;&#66;&#117; {{amount}}",
          money_with_currency_format: "&#70;&#66;&#117; {{amount}} BIF",
        },
        BWP: {
          money_format: "P{{amount}}",
          money_with_currency_format: "P{{amount}} BWP",
        },
        BND: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} BND",
        },
        CVE: {
          money_format: "&#36; {{amount}}",
          money_with_currency_format: "&#36; {{amount}} CVE",
        },
        KMF: {
          money_format: "&#67;&#70; {{amount}}",
          money_with_currency_format: "&#67;&#70; {{amount}} KMF",
        },
        CUC: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} CUC",
        },
        CUP: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} CUP",
        },
        CDF: {
          money_format: "&#70;&#67; {{amount}}",
          money_with_currency_format: "&#70;&#67; {{amount}} CDF",
        },
        DJF: {
          money_format: "&#70;&#100;&#106; {{amount}}",
          money_with_currency_format: "&#70;&#100;&#106; {{amount}} DJF",
        },
        ERN: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} ERN",
        },
        FKP: {
          money_format: "&#163; {{amount}}",
          money_with_currency_format: "&#163; {{amount}} FKP",
        },
        GIP: {
          money_format: "&#163; {{amount}}",
          money_with_currency_format: "&#163; {{amount}} GIP",
        },
        XAU: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} XAU",
        },
        GGP: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} GGP",
        },
        GNF: {
          money_format: "&#70;&#71; {{amount}}",
          money_with_currency_format: "&#70;&#71; {{amount}} GNF",
        },
        HTG: {
          money_format: "&#71; {{amount}}",
          money_with_currency_format: "&#71; {{amount}} HTG",
        },
        XDR: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} XDR",
        },
        IDR: {
          money_format: "{{amount_with_comma_separator}} IDR",
          money_with_currency_format: "Rp {{amount_with_comma_separator}} IDR",
        },
        IQD: {
          money_format: "&#1593;.&#1583; {{amount}}",
          money_with_currency_format: "&#1593;.&#1583; {{amount}} IQD",
        },
        IMP: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} IMP",
        },
        LAK: {
          money_format: "&#8365; {{amount}}",
          money_with_currency_format: "&#8365; {{amount}} LAK",
        },
        LSL: {
          money_format: "&#76; {{amount}}",
          money_with_currency_format: "&#76; {{amount}} LSL",
        },
        LRD: {
          money_format: "&#36; {{amount}}",
          money_with_currency_format: "&#36; {{amount}} LRD",
        },
        LYD: {
          money_format: "&#1604;.&#1583; {{amount}}",
          money_with_currency_format: "&#1604;.&#1583; {{amount}} LYD",
        },
        MWK: {
          money_format: "&#77;&#75; {{amount}}",
          money_with_currency_format: "&#77;&#75; {{amount}} MWK",
        },
        MRO: {
          money_format: "&#85;&#77; {{amount}}",
          money_with_currency_format: "&#85;&#77; {{amount}} MRO",
        },
        KPW: {
          money_format: "&#8361; {{amount}}",
          money_with_currency_format: "&#8361; {{amount}} KPW",
        },
        OMR: {
          money_format: "{{amount_with_comma_separator}} OMR",
          money_with_currency_format: "{{amount_with_comma_separator}} OMR",
        },
        PAB: {
          money_format: "&#66;&#47;&#46; {{amount}}",
          money_with_currency_format: "&#66;&#47;&#46; {{amount}} PAB",
        },
        SHP: {
          money_format: "&#163; {{amount}}",
          money_with_currency_format: "&#163; {{amount}} SHP",
        },
        SVC: {
          money_format: "&#36; {{amount}}",
          money_with_currency_format: "&#36; {{amount}} SVC",
        },
        SLL: {
          money_format: "&#76;&#101; {{amount}}",
          money_with_currency_format: "&#76;&#101; {{amount}} SLL",
        },
        XAG: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} XAG",
        },
        SBD: {
          money_format: "&#36; {{amount}}",
          money_with_currency_format: "&#36; {{amount}} SBD",
        },
        SOS: {
          money_format: "&#83; {{amount}}",
          money_with_currency_format: "&#83; {{amount}} SOS",
        },
        SDG: {
          money_format: "&#163; {{amount}}",
          money_with_currency_format: "&#163; {{amount}} SDG",
        },
        SRD: {
          money_format: "&#36; {{amount}}",
          money_with_currency_format: "&#36; {{amount}} SRD",
        },
        SZL: {
          money_format: "&#76; {{amount}}",
          money_with_currency_format: "&#76; {{amount}} SZL",
        },
        TJS: {
          money_format: "&#84;&#74;&#83; {{amount}}",
          money_with_currency_format: "&#84;&#74;&#83; {{amount}} TJS",
        },
        TOP: {
          money_format: "&#84;&#36; {{amount}}",
          money_with_currency_format: "&#84;&#36; {{amount}} TOP",
        },
        TMT: {
          money_format: "&#109; {{amount}}",
          money_with_currency_format: "&#109; {{amount}} TMT",
        },
        UZS: {
          money_format: "&#1083;&#1074; {{amount}}",
          money_with_currency_format: "&#1083;&#1074; {{amount}} UZS",
        },
        YER: {
          money_format: "&#65020; {{amount}}",
          money_with_currency_format: "&#65020; {{amount}} YER",
        },
        BGN: {
          money_format: "{{amount}} \u0110\xBB\u0110\u02DB",
          money_with_currency_format: "{{amount}} \u0110\xBB\u0110\u02DB BGN",
        },
        MMK: {
          money_format: "K{{amount}}",
          money_with_currency_format: "K{{amount}} MMK",
        },
        KHR: {
          money_format: "KHR{{amount}}",
          money_with_currency_format: "KHR{{amount}}",
        },
        KYD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} KYD",
        },
        XAF: {
          money_format: "FCFA{{amount}}",
          money_with_currency_format: "FCFA{{amount}} XAF",
        },
        CLP: {
          money_format: "${{amount_no_decimals}}",
          money_with_currency_format: "${{amount_no_decimals}} CLP",
        },
        CNY: {
          money_format: "&#165;{{amount}}",
          money_with_currency_format: "&#165;{{amount}} CNY",
        },
        COP: {
          money_format: "${{amount_with_comma_separator}}",
          money_with_currency_format: "${{amount_with_comma_separator}} COP",
        },
        CRC: {
          money_format: "&#8353; {{amount_with_comma_separator}}",
          money_with_currency_format:
            "&#8353; {{amount_with_comma_separator}} CRC",
        },
        HRK: {
          money_format: "{{amount_with_comma_separator}} kn",
          money_with_currency_format: "{{amount_with_comma_separator}} kn HRK",
        },
        CZK: {
          money_format: "{{amount_with_comma_separator}} K&#269;",
          money_with_currency_format: "{{amount_with_comma_separator}} K&#269;",
        },
        DKK: {
          money_format: "{{amount_with_comma_separator}}",
          money_with_currency_format: "kr.{{amount_with_comma_separator}}",
        },
        DOP: {
          money_format: "RD$ {{amount}}",
          money_with_currency_format: "RD$ {{amount}}",
        },
        XCD: {
          money_format: "${{amount}}",
          money_with_currency_format: "EC${{amount}}",
        },
        EGP: {
          money_format: "LE {{amount}}",
          money_with_currency_format: "LE {{amount}} EGP",
        },
        ETB: {
          money_format: "Br{{amount}}",
          money_with_currency_format: "Br{{amount}} ETB",
        },
        XPF: {
          money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
          money_with_currency_format:
            "{{amount_no_decimals_with_comma_separator}} XPF",
        },
        FJD: {
          money_format: "${{amount}}",
          money_with_currency_format: "FJ${{amount}}",
        },
        GMD: {
          money_format: "D {{amount}}",
          money_with_currency_format: "D {{amount}} GMD",
        },
        GHS: {
          money_format: "GH&#8373;{{amount}}",
          money_with_currency_format: "GH&#8373;{{amount}}",
        },
        GTQ: {
          money_format: "Q{{amount}}",
          money_with_currency_format: "{{amount}} GTQ",
        },
        GYD: {
          money_format: "G${{amount}}",
          money_with_currency_format: "${{amount}} GYD",
        },
        GEL: {
          money_format: "{{amount}} GEL",
          money_with_currency_format: "{{amount}} GEL",
        },
        HNL: {
          money_format: "L {{amount}}",
          money_with_currency_format: "L {{amount}} HNL",
        },
        HKD: {
          money_format: "${{amount}}",
          money_with_currency_format: "HK${{amount}}",
        },
        HUF: {
          money_format: "{{amount_no_decimals_with_comma_separator}}",
          money_with_currency_format:
            "{{amount_no_decimals_with_comma_separator}} Ft",
        },
        ISK: {
          money_format: "{{amount_no_decimals}} kr",
          money_with_currency_format: "{{amount_no_decimals}} kr ISK",
        },
        INR: {
          money_format: "Rs. {{amount}}",
          money_with_currency_format: "Rs. {{amount}}",
        },
        IDR: {
          money_format: "{{amount_with_comma_separator}}",
          money_with_currency_format: "Rp {{amount_with_comma_separator}}",
        },
        ILS: {
          money_format: "{{amount}} NIS",
          money_with_currency_format: "{{amount}} NIS",
        },
        JMD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} JMD",
        },
        JPY: {
          money_format: "&#165;{{amount_no_decimals}}",
          money_with_currency_format: "&#165;{{amount_no_decimals}} JPY",
        },
        JEP: {
          money_format: "&pound;{{amount}}",
          money_with_currency_format: "&pound;{{amount}} JEP",
        },
        JOD: {
          money_format: "{{amount}}0 JD",
          money_with_currency_format: "{{amount}}0 JOD",
        },
        KZT: {
          money_format: "{{amount}} KZT",
          money_with_currency_format: "{{amount}} KZT",
        },
        KES: {
          money_format: "KSh{{amount}}",
          money_with_currency_format: "KSh{{amount}}",
        },
        KWD: {
          money_format: "{{amount}}0 KD",
          money_with_currency_format: "{{amount}}0 KWD",
        },
        KGS: {
          money_format: "\u0110\xBB\u0110\u02DB{{amount}}",
          money_with_currency_format: "\u0110\xBB\u0110\u02DB{{amount}}",
        },
        LVL: {
          money_format: "Ls {{amount}}",
          money_with_currency_format: "Ls {{amount}} LVL",
        },
        LBP: {
          money_format: "L&pound;{{amount}}",
          money_with_currency_format: "L&pound;{{amount}} LBP",
        },
        LTL: {
          money_format: "{{amount}} Lt",
          money_with_currency_format: "{{amount}} Lt",
        },
        MGA: {
          money_format: "Ar {{amount}}",
          money_with_currency_format: "Ar {{amount}} MGA",
        },
        MKD: {
          money_format: "\u0110\xB4\u0110\xB5\u0110\u02DD {{amount}}",
          money_with_currency_format:
            "\u0110\xB4\u0110\xB5\u0110\u02DD {{amount}} MKD",
        },
        MOP: {
          money_format: "MOP${{amount}}",
          money_with_currency_format: "MOP${{amount}}",
        },
        MVR: {
          money_format: "Rf{{amount}}",
          money_with_currency_format: "Rf{{amount}} MRf",
        },
        MXN: {
          money_format: "$ {{amount}}",
          money_with_currency_format: "$ {{amount}} MXN",
        },
        MYR: {
          money_format: "RM{{amount}} MYR",
          money_with_currency_format: "RM{{amount}} MYR",
        },
        MUR: {
          money_format: "Rs {{amount}}",
          money_with_currency_format: "Rs {{amount}} MUR",
        },
        MDL: {
          money_format: "{{amount}} MDL",
          money_with_currency_format: "{{amount}} MDL",
        },
        MAD: {
          money_format: "{{amount}} dh",
          money_with_currency_format: "Dh {{amount}} MAD",
        },
        MNT: {
          money_format: "{{amount_no_decimals}} &#8366",
          money_with_currency_format: "{{amount_no_decimals}} MNT",
        },
        MZN: {
          money_format: "{{amount}} Mt",
          money_with_currency_format: "Mt {{amount}} MZN",
        },
        NAD: {
          money_format: "N${{amount}}",
          money_with_currency_format: "N${{amount}} NAD",
        },
        NPR: {
          money_format: "Rs{{amount}}",
          money_with_currency_format: "Rs{{amount}} NPR",
        },
        ANG: {
          money_format: "&fnof;{{amount}}",
          money_with_currency_format: "{{amount}} NA&fnof;",
        },
        NZD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} NZD",
        },
        NIO: {
          money_format: "C${{amount}}",
          money_with_currency_format: "C${{amount}} NIO",
        },
        NGN: {
          money_format: "&#8358;{{amount}}",
          money_with_currency_format: "&#8358;{{amount}} NGN",
        },
        NOK: {
          money_format: "kr {{amount_with_comma_separator}}",
          money_with_currency_format: "kr {{amount_with_comma_separator}} NOK",
        },
        OMR: {
          money_format: "{{amount_with_comma_separator}} OMR",
          money_with_currency_format: "{{amount_with_comma_separator}} OMR",
        },
        PKR: {
          money_format: "Rs.{{amount}}",
          money_with_currency_format: "Rs.{{amount}} PKR",
        },
        PGK: {
          money_format: "K {{amount}}",
          money_with_currency_format: "K {{amount}} PGK",
        },
        PYG: {
          money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
          money_with_currency_format:
            "Gs. {{amount_no_decimals_with_comma_separator}} PYG",
        },
        PEN: {
          money_format: "S/. {{amount}}",
          money_with_currency_format: "S/. {{amount}} PEN",
        },
        PHP: {
          money_format: "&#8369;{{amount}}",
          money_with_currency_format: "&#8369;{{amount}} PHP",
        },
        PLN: {
          money_format: "{{amount_with_comma_separator}} zl",
          money_with_currency_format: "{{amount_with_comma_separator}} zl PLN",
        },
        QAR: {
          money_format: "QAR {{amount_with_comma_separator}}",
          money_with_currency_format: "QAR {{amount_with_comma_separator}}",
        },
        RON: {
          money_format: "{{amount_with_comma_separator}} lei",
          money_with_currency_format: "{{amount_with_comma_separator}} lei RON",
        },
        RUB: {
          money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
          money_with_currency_format:
            "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB",
        },
        RWF: {
          money_format: "{{amount_no_decimals}} RF",
          money_with_currency_format: "{{amount_no_decimals}} RWF",
        },
        WST: {
          money_format: "WS$ {{amount}}",
          money_with_currency_format: "WS$ {{amount}} WST",
        },
        SAR: {
          money_format: "{{amount}} SR",
          money_with_currency_format: "{{amount}} SAR",
        },
        STD: {
          money_format: "Db {{amount}}",
          money_with_currency_format: "Db {{amount}} STD",
        },
        RSD: {
          money_format: "{{amount}} RSD",
          money_with_currency_format: "{{amount}} RSD",
        },
        SCR: {
          money_format: "Rs {{amount}}",
          money_with_currency_format: "Rs {{amount}} SCR",
        },
        SGD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} SGD",
        },
        SYP: {
          money_format: "S&pound;{{amount}}",
          money_with_currency_format: "S&pound;{{amount}} SYP",
        },
        ZAR: {
          money_format: "R {{amount}}",
          money_with_currency_format: "R {{amount}} ZAR",
        },
        KRW: {
          money_format: "&#8361;{{amount_no_decimals}}",
          money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW",
        },
        LKR: {
          money_format: "Rs {{amount}}",
          money_with_currency_format: "Rs {{amount}} LKR",
        },
        SEK: {
          money_format: "{{amount_no_decimals}} kr",
          money_with_currency_format: "{{amount_no_decimals}} kr SEK",
        },
        CHF: {
          money_format: "SFr. {{amount}}",
          money_with_currency_format: "SFr. {{amount}} CHF",
        },
        TWD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} TWD",
        },
        THB: {
          money_format: "{{amount}} &#xe3f;",
          money_with_currency_format: "{{amount}} &#xe3f; THB",
        },
        TZS: {
          money_format: "{{amount}} TZS",
          money_with_currency_format: "{{amount}} TZS",
        },
        TTD: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}} TTD",
        },
        TND: {
          money_format: "{{amount}}",
          money_with_currency_format: "{{amount}} DT",
        },
        TRY: {
          money_format: "{{amount}}TL",
          money_with_currency_format: "{{amount}}TL",
        },
        UGX: {
          money_format: "Ush {{amount_no_decimals}}",
          money_with_currency_format: "Ush {{amount_no_decimals}} UGX",
        },
        UAH: {
          money_format: "\xE2\u201A\xB4{{amount}}",
          money_with_currency_format: "\xE2\u201A\xB4{{amount}} UAH",
        },
        AED: {
          money_format: "Dhs. {{amount}}",
          money_with_currency_format: "Dhs. {{amount}} AED",
        },
        UYU: {
          money_format: "${{amount_with_comma_separator}}",
          money_with_currency_format: "${{amount_with_comma_separator}} UYU",
        },
        VUV: {
          money_format: "${{amount}}",
          money_with_currency_format: "${{amount}}VT",
        },
        VEF: {
          money_format: "Bs. {{amount_with_comma_separator}}",
          money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF",
        },
        VND: {
          money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
          money_with_currency_format:
            "{{amount_no_decimals_with_comma_separator}} VND",
        },
        XBT: {
          money_format: "{{amount_no_decimals}} BTC",
          money_with_currency_format: "{{amount_no_decimals}} BTC",
        },
        XOF: {
          money_format: "CFA{{amount}}",
          money_with_currency_format: "CFA{{amount}} XOF",
        },
        ZMW: {
          money_format: "K{{amount_no_decimals_with_comma_separator}}",
          money_with_currency_format:
            "ZMW{{amount_no_decimals_with_comma_separator}}",
        },
      }),
        (this.currentCurrency = bstore.get("currentCurrency")),
        (this.format = _settings.currencyFormat || "money_with_currency_format"),
        (this.events = events2),
        this.currentCurrency &&
          Shopify.currency.active !== this.currentCurrency &&
          this.convertAll({}),
        this.events.on("booster:content:update", (params = {}) =>
          this.convertAll(params)
        ),
        this.events.on("booster:price:update", this.priceUpdate.bind(this));
    }
    formatMoney(o, m) {
      typeof o == "string" && (o = o.replace(".", ""));
      var t = "",
        n = /\{\{\s*(\w+)\s*\}\}/,
        a = m || "${{amount}}";
      function _(o2, m2) {
        return o2 === void 0 ? m2 : o2;
      }
      function r(o2, m2, t2, n2) {
        if (
          ((m2 = _(m2, 2)),
          (t2 = _(t2, ",")),
          (n2 = _(n2, ".")),
          isNaN(o2) || o2 == null)
        )
          return 0;
        var a2 = (o2 = (o2 / 100).toFixed(m2)).split(".");
        return (
          a2[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + t2) +
          (a2[1] ? n2 + a2[1] : "")
        );
      }
      switch (a.match(n)[1]) {
        case "amount":
          t = r(o, 2);
          break;
        case "amount_no_decimals":
          t = r(o, 0);
          break;
        case "amount_with_comma_separator":
          t = r(o, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          t = r(o, 0, ".", ",");
      }
      return a.replace(n, t);
    }
    priceUpdate({ elements }) {
      let oldCurrency = Shopify.currency.active,
        newCurrency = bstore.get("currentCurrency"),
        newFormat = this.getFormat(newCurrency),
        oldFormat = this.getFormat(oldCurrency);
      if (oldCurrency != newCurrency)
        for (let element of elements)
          this.elemConvert({
            element,
            oldCurrency,
            newCurrency,
            oldFormat,
            newFormat,
          });
    }
    elemConvert({
      element,
      oldCurrency = !1,
      newCurrency = !1,
      newFormat = !1,
      oldFormat = !1,
    }) {
      let amount = element.innerText;
      if (!amount || amount.trim() == "") return;
      let oldc = oldCurrency || Shopify.currency.active;
      if (!oldc) return;
      let newc = newCurrency || bstore.get("currentCurrency");
      if (!newc) return;
      let newf = newFormat || this.getFormat(newc),
        oldf = oldFormat || this.getFormat(oldc),
        u;
      (u =
        oldf.indexOf("amount_no_decimals") !== -1
          ? Currency.convert(
              100 * parseInt(amount.replace(/[^0-9]/g, ""), 10),
              oldc,
              newc
            )
          : oldc === "JOD" || oldc == "KWD" || oldc == "BHD"
          ? Currency.convert(
              parseInt(amount.replace(/[^0-9]/g, ""), 10) / 10,
              oldc,
              newc
            )
          : Currency.convert(
              parseInt(amount.replace(/[^0-9]/g, ""), 10),
              oldc,
              newc
            )),
        (element.innerHTML = this.formatMoney(u, newf)),
        (element.dataset.currency = newc);
    }
    convert({ amount = !1, oldc = !1, newc = !1 }) {
      if (
        !amount ||
        ((oldc = oldc || Shopify.currency.active), !oldc) ||
        ((newc = newc || bstore.get("currentCurrency")), !newc)
      )
        return amount;
      let newf = this.getFormat(newc),
        oldf = this.getFormat(oldc),
        u;
      return (
        (u =
          oldf.indexOf("amount_no_decimals") !== -1
            ? Currency.convert(
                100 * parseInt(amount.replace(/[^0-9]/g, ""), 10),
                oldc,
                newc
              )
            : oldc === "JOD" || oldc == "KWD" || oldc == "BHD"
            ? Currency.convert(
                parseInt(amount.replace(/[^0-9]/g, ""), 10) / 10,
                oldc,
                newc
              )
            : Currency.convert(
                parseInt(amount.replace(/[^0-9]/g, ""), 10),
                oldc,
                newc
              )),
        this.formatMoney(u, newf)
      );
    }
    convertAll({
      oldCurrency = !1,
      newCurrency = !1,
      selector = ".jsPrice",
      format = this.format,
    }) {
      let oldc = oldCurrency || Shopify.currency.active;
      if (!oldc) return;
      let newc = newCurrency || bstore.get("currentCurrency");
      if (!newc || newc == oldc) return;
      let oldf = this.moneyFormats[oldc][format] || "{{amount}}",
        newf = this.moneyFormats[newc][format] || "{{amount}}",
        conts = document.querySelectorAll(selector);
      for (let i = 0, maxi = conts.length; i < maxi; ++i) {
        let u,
          elem = conts[i];
        if (elem.dataset.currency == newc) continue;
        let amount = elem.innerText;
        !amount ||
          amount.trim() == "" ||
          ((u =
            oldf.indexOf("amount_no_decimals") !== -1
              ? Currency.convert(
                  100 * parseInt(amount.replace(/[^0-9]/g, ""), 10),
                  oldc,
                  newc
                )
              : oldc === "JOD" || oldc == "KWD" || oldc == "BHD"
              ? Currency.convert(
                  parseInt(amount.replace(/[^0-9]/g, ""), 10) / 10,
                  oldc,
                  newc
                )
              : Currency.convert(
                  parseInt(amount.replace(/[^0-9]/g, ""), 10),
                  oldc,
                  newc
                )),
          (elem.innerHTML = this.formatMoney(u, newf)),
          (elem.dataset.currency = newc));
      }
      bstore.set("currentCurrency", newc), (this.currentCurrency = newc);
    }
    getFormat(currency = !1, format = !1) {
      return (
        (format =
          format || _settings.currencyFormat || "money_with_currency_format"),
        (currency = currency || Shopify.currency.active),
        this.moneyFormats[currency][format]
      );
    }
  }
  class BstrFreeShipping {
    constructor({ events: events2, cfx }) {
      (this.events = events2),
        (this.cfx = cfx),
        (this.goal = parseFloat(_settings.freeShippingAmount.trim()) * 100),
        (this.current = 0),
        (this.format = this.cfx.getFormat(Shopify.currency.active)),
        this.events.on("booster:cart:update", this.updateBars.bind(this)),
        this.events.on("booster:content:update", this.updateBars.bind(this));
    }
    updateBars(params = {}) {
      let current = (params.data && params.data.total_raw) || this.current;
      this.current = current;
      let percentage = Math.min((current / this.goal) * 100, 100),
        left = this.cfx.convert({
          amount: this.cfx.formatMoney(this.goal - current, this.format),
        }),
        bars = document.querySelectorAll("[data-free-shipping-bar]"),
        texts = document.querySelectorAll("[data-free-shipping-text]");
      for (let b of bars) b.style.width = percentage + "%";
      for (let t of texts)
        t.innerHTML =
          percentage == 100
            ? t.dataset.gotFreeShipping
            : t.dataset.freeShippingText.replace(
                "%AMOUNT%",
                `<span class="jsPrice">${left}</span>`
              );
    }
  }
  class BstrLocalize {
    constructor({ events: events2, cfx }) {
      (this.events = events2),
        (this.cfx = cfx),
        _settings.geolocation &&
          this.events.on("booster:geo:visitor", this.localize.bind(this));
    }
    async localize(params) {
      if (bstore.get("bstrLocalized")) return;
      bstore.set("bstrLocalized", !0, 1440);
      let currency = params.currency.code,
        language = params.language.code,
        return_to = window.location.pathname,
        redirect = !1;
      if (
        language != Shopify.locale &&
        Object.keys(bstri18n.locales).includes(language)
      ) {
        let lang = bstri18n.locales[language],
          current = bstri18n.locales[Shopify.locale];
        current.primary || (return_to = return_to.replace(`${current.url}`, "")),
          lang.primary || (return_to = `${lang.url}${return_to}`),
          (redirect = !0);
      }
      let mode = bstri18n.currency_mode,
        currencies = bstri18n.currencies;
      if (mode != "none" && currencies.includes(currency)) {
        if (mode == "convert" && bstore.get("currentCurrency") != currency)
          this.cfx.convertAll({
            oldCurrency: bstore.get("currentCurrency") || Shopify.currency.active,
            newCurrency: currency,
          }),
            this.events.trigger("booster:currency:changed");
        else if (Shopify.currency.active != currency) {
          let form = new FormData();
          if (
            (form.append("form_type", "currency"),
            form.append("currency", currency),
            await fetch(`${window.Shopify.routes.root}cart/update`, {
              body: form,
              method: "POST",
            }),
            !redirect)
          )
            return window.location.reload();
        }
      }
      if (redirect) return (window.location = return_to);
    }
  }
  class BstrCntr {
    constructor(id = "[data-bstr-cntr]") {
      (this.id = id),
        (this.counters = []),
        (this.interval = !1),
        this.initCounters();
    }
    initCounters() {
      let cts = document.querySelectorAll(`${this.id}:not([data-bstr-initd])`);
      if (!cts.length) return;
      let interval = parseInt(cts[0].dataset.bstrCntrInterval) * 1e3;
      this.interval && clearInterval(this.interval);
      for (let ct of cts) this.counters.push(ct), (ct.dataset.bstrInitd = "true");
      this.interval = setInterval(this.countManagement.bind(this), interval);
    }
    countManagement() {
      let cache = {};
      for (let i = 0, maxi = this.counters.length; i < maxi; ++i) {
        let item = this.counters[i];
        if (cache[item.dataset.bstrCntrId]) {
          item.innerText = cache[item.dataset.bstrCntrId];
          continue;
        }
        let limit = item.dataset.bstrCntrLimit,
          current = parseInt(item.innerText) || limit,
          value = getRandomInt(
            Math.max(current - current * 0.1, 1),
            Math.min(current + current * 0.1, limit)
          );
        (item.innerText = value), (cache[item.dataset.bstrCntrId] = value);
      }
    }
  }
  class BstrCopycat {
    constructor() {
      document.addEventListener("contextmenu", function (e) {
        return e.preventDefault();
      }),
        this.preventInspectElement(),
        _settings.copycatText && this.preventTextSelect();
    }
    preventTextSelect() {
      let style = document.createElement("style");
      (style.innerText =
        "*:not(textarea):not(input):not(select):not(form):not(datalist):not(fieldset):not(option) {-webkit-touch-callout: none !important;-webkit-user-select: none !important;-khtml-user-select: none !important;-moz-user-select: none !important;-ms-user-select: none !important;user-select: none !important;}"),
        document.body.appendChild(style);
    }
    preventInspectElement() {
      document.onkeydown = function (e) {
        if (
          !e.defaultPrevented &&
          (e.code == "F12" ||
            e.key == "F12" ||
            (e.ctrlKey &&
              e.shiftKey &&
              (e.key == "j" || e.key == "J" || e.code == "KeyJ")) ||
            (e.ctrlKey &&
              e.shiftKey &&
              (e.key == "c" || e.key == "C" || e.code == "KeyC")) ||
            (e.ctrlKey &&
              e.shiftKey &&
              (e.key == "i" || e.key == "I" || e.code == "KeyI")) ||
            (e.ctrlKey && (e.key == "u" || e.key == "U" || e.code == "KeyU")) ||
            (_settings.copycatText &&
              ((e.ctrlKey &&
                (e.key == "c" || e.key == "C" || e.code == "KeyC")) ||
                (e.ctrlKey &&
                  (e.key == "a" || e.key == "A" || e.code == "KeyA")) ||
                (e.ctrlKey &&
                  (e.key == "x" || e.key == "X" || e.code == "KeyX")))))
        )
          return !1;
      };
    }
  }
  class BstrCountdown {
    constructor({ events: events2 }) {
      (this.events = events2),
        this.init(),
        this.events.on("booster:content:update", () => this.init());
    }
    async init(container = document) {
      let bstrCts = container.querySelectorAll("[data-countdown]");
      this.bstrCts
        ? this.bstrCts.push(...bstrCts)
        : (this.bstrCts = [...bstrCts]);
      let ctSettings = bstore.get("bstrCts");
      ctSettings || (ctSettings = {});
      let time = new Date().getTime(),
        randomize = parseInt(_settings.countdownRandom);
      function enumMultiplier(format) {
        switch (format) {
          case "days":
            return 864e5;
          case "hours":
            return 36e5;
          case "minutes":
            return 6e4;
          case "seconds":
            return 1e3;
          default:
            return 864e5;
        }
      }
      let expiry, minExp, maxExp;
      if (_settings.countdownTime.includes("/"))
        (expiry = new Date(_settings.countdownTime).getTime()),
          (minExp = expiry - randomize * 864e5),
          (maxExp = expiry + randomize * 864e5);
      else {
        let expiry2 = parseInt(_settings.countdownTime),
          multiply = enumMultiplier(_settings.countdownTimeFormat);
        (minExp = time + Math.abs(expiry2 - randomize) * multiply),
          (maxExp = time + Math.abs(expiry2 + randomize) * multiply);
      }
      function getExpiry(timer, type, set = !0) {
        if (type == "app") {
          let newTime = getRandomInt(minExp, maxExp);
          return (timer.dataset.expiryTime = newTime), newTime;
        } else {
          let expiry2,
            duration = timer.dataset.duration;
          return (
            duration.includes("/")
              ? (expiry2 = new Date(duration).getTime())
              : (expiry2 =
                  time +
                  parseInt(duration) *
                    enumMultiplier(timer.dataset.durationFormat)),
            set && (timer.dataset.expiryTime = expiry2),
            expiry2
          );
        }
      }
      for (let i = 0, maxi = bstrCts.length; i < maxi; ++i) {
        let timer = bstrCts[i];
        timer.removeAttribute("data-countdown");
        let key = timer.dataset.ctKey,
          ctType =
            timer.dataset.duration && timer.dataset.durationFormat
              ? "block"
              : "app";
        if (!ctSettings[key] || ctSettings[key] < time || Shopify.designMode) {
          let expires = getExpiry(timer, ctType);
          ctSettings[key] = expires;
        } else if (ctType == "app")
          if (ctSettings[key] > maxExp) {
            let newTime = getRandomInt(minExp, maxExp);
            (ctSettings[key] = newTime), (timer.dataset.expiryTime = newTime);
          } else timer.dataset.expiryTime = ctSettings[key];
        else {
          let expires = getExpiry(timer, ctType, !1);
          ctSettings[key] > expires
            ? ((timer.dataset.expiryTime = expiry), (ctSettings[key] = expires))
            : (timer.dataset.expiryTime = ctSettings[key]);
        }
      }
      bstore.set("bstrCts", ctSettings, 1440),
        this.countdownStarted ||
          (setInterval(this.tickCountdowns.bind(this), 1e3),
          (this.countdownStarted = !0));
    }
    tickCountdowns() {
      for (let i = 0, maxi = this.bstrCts.length; i < maxi; ++i)
        this.tickCountdown(this.bstrCts[i]);
    }
    tickCountdown(ct) {
      if (ct.dataset.countdownTimedOut == "true") return;
      let delta = (parseInt(ct.dataset.expiryTime) - Date.now()) / 1e3,
        daysEl = ct.querySelector(".days"),
        hoursEl = ct.querySelector(".hours"),
        minutesEl = ct.querySelector(".minutes"),
        secondsEl = ct.querySelector(".seconds");
      if (delta <= 0) {
        if (ct.dataset.ctKey == "cart-ct-timer") {
          ct.dataset.expiryTime = Date.now() + 3e5;
          return;
        }
        (ct.dataset.countdownTimedOut = "true"),
          daysEl && (daysEl.innerText = "00"),
          hoursEl && (hoursEl.innerText = "00"),
          minutesEl && (minutesEl.innerText = "00"),
          secondsEl && (secondsEl.innerText = "00");
        return;
      }
      let days = Math.floor(delta / 86400);
      daysEl && (daysEl.innerText = (days >= 10 && days) || "0" + days),
        (delta -= days * 86400);
      let hours = Math.floor(delta / 3600) % 24;
      (delta -= hours * 3600),
        hoursEl && (hoursEl.innerText = (hours >= 10 && hours) || "0" + hours);
      let minutes = Math.floor(delta / 60) % 60;
      (delta -= minutes * 60),
        minutesEl &&
          (minutesEl.innerText = (minutes >= 10 && minutes) || "0" + minutes);
      let seconds = delta % 60;
      secondsEl &&
        (secondsEl.innerText =
          (seconds >= 10 && Math.floor(seconds)) || "0" + Math.floor(seconds));
    }
  }
  class BstrDynTitle {
    constructor() {
      this.originalTitle = document.title;
      let intr = parseInt(_settings.dynTitleIntr);
      (this.intr = isNaN(intr) ? 2500 : intr * 1e3),
        this.initLeavePage(),
        this.initOnPage();
    }
    initLeavePage() {
      let titles = _settings.BPDynTitle.trim().split(`
  `);
      (this.LPTitles = [this.originalTitle, ...titles]),
        window.addEventListener("blur", () => {
          clearInterval(this.OPRotation),
            (this.OPRotation = !1),
            (document.title = this.originalTitle),
            titles[0] != "" &&
              (this.LPRotation ||
                (this.LPRotation = setInterval(
                  () => this.rotateTitles(this.LPTitles),
                  this.intr
                )));
        });
    }
    initOnPage() {
      let titles = _settings.OPDynTitle.trim().split(`
  `);
      (this.OPTitles = [this.originalTitle, ...titles]),
        window.addEventListener("focus", () => {
          clearInterval(this.LPRotation),
            (this.LPRotation = !1),
            (document.title = this.originalTitle),
            titles[0] != "" &&
              (this.OPRotation ||
                (this.OPRotation = setInterval(
                  () => this.rotateTitles(this.OPTitles),
                  this.intr
                )));
        }),
        !this.LPRotation &&
          titles[0] != "" &&
          (this.OPRotation = setInterval(
            () => this.rotateTitles(this.OPTitles),
            this.intr
          ));
    }
    rotateTitles(titles) {
      let len = titles.length,
        ct = titles.indexOf(document.title);
      ++ct, ct >= len && (ct = 0), (document.title = titles[ct]);
    }
  }
  class BstrElements {
    constructor({ events: events2, basync, cfx, cart }) {
      (this.events = events2),
        (this.cfx = cfx),
        (this.cart = cart),
        (this.basync = basync),
        (this.stock = new BstrStock({ events: events2 })),
        (this.marqueeIntervals = {}),
        (this.cardTemplate = document.getElementById("productCardTemplate")),
        this.checkPagination(),
        this.initMarquees(),
        this.initElements(),
        this.events.on("booster:content:update", this.initElements.bind(this)),
        this.events.on("booster:currency:changed", () => this.cfxInput()),
        (this.rendering = !1);
    }
    initElements() {
      this.quantityHandlers(),
        this.cfxInput(),
        this.initSearch(),
        this.boosterRevert(),
        this.localizeDates();
    }
    async initMarquees() {
      let marquees = document.querySelectorAll(
        '[data-blocktype="barTextMarquee"]'
      );
      for (let i = 0, maxi = marquees.length; i < maxi; i++) {
        let element = marquees[i],
          id = element.dataset.blockid;
        var self2 = this;
        this.marqueeIntervals[id] = setInterval(
          self2.scrollMarquee,
          2e3,
          element
        );
      }
    }
    scrollMarquee(container) {
      if (container.dataset.currentmessage >= container.dataset.messagescount) {
        (container.dataset.currentmessage = 0),
          (container.style.transform = "translateY(0%)");
        return;
      }
      container.dataset.currentmessage++,
        (container.style.transform = `translateY(-${
          container.dataset.currentmessage * 100
        }%)`);
    }
    checkPagination() {
      if (_settings.pagination == "infinite") {
        let pList = document.querySelector(".row--product.product__list");
        if (!pList) return;
        (self = this),
          window.addEventListener(
            "scroll",
            debounce(() => {
              if (
                window.innerHeight + window.scrollY >= pList.offsetHeight &&
                this.rendering === !1
              ) {
                let next = document.querySelector(".pagination--hidden");
                if (!next) return;
                (this.rendering = !0), self.renderChangePage(!1, next, !1);
              }
            }, 250)
          );
      }
    }
    boosterRevert() {
      let reverts = document.querySelectorAll(
        ".booster--revert div:not(.booster--revert)"
      );
      for (let r = 0, maxr = reverts.length; r < maxr; ++r)
        reverts[r].classList.add("booster--revert");
    }
    initSearch() {
      let searchFields = document.querySelectorAll(
        "input[data-search]:not([data-bstr-initd])"
      );
      for (let i = 0, maxi = searchFields.length; i < maxi; ++i)
        (searchFields[i].dataset.bstrInitd = "true"),
          (searchFields[i].oninput = debounce(
            this.searchSuggest.bind(this),
            230,
            !1
          ));
    }
    cfxInput() {
      if (bstri18n.currency_mode == "convert") {
        let c = bstore.get("currentCurrency");
        if (!c || c == Shopify.currency.active) return;
        document.querySelectorAll("[data-currency-selector]").forEach((e) => {
          e.value = c;
        });
      }
    }
    quantityHandlers() {
      let inputs = document.querySelectorAll(
        "[data-qty-int-input]:not([data-bstr-initd])"
      );
      for (let inp of inputs) {
        inp.dataset.lastQty = inp.value;
        (inp.dataset.bstrInitd = "true"),
          (inp.oninput = debounce(
            (e) => {
              inp.onchange(e);
            },
            500,
            !1
          ));
      }
    }
    convertCurrencyChange(select) {
      let currency = select.value;
      currency != bstore.get("currentCurrency") &&
        this.cfx.convertAll({
          oldCurrency: bstore.get("currentCurrency") || Shopify.currency.active,
          newCurrency: currency,
        });
    }
    submitCurrencyChange(select) {
      return select.closest("form").submit();
    }
    languageChange(select) {
      return (window.location = select.value);
    }
    stickyBuy(button, e) {
      if (button.dataset.productId) {
        let container = button.closestEl(".sticky--mobile");
        if (container.classList.contains("sticky--closed"))
          return container.classList.remove("sticky--closed");
      } else {
        let id = button.dataset.buyButton,
          form = document.getElementById("product_form_" + id);
        form && this.cart.addToCart(e, form);
      }
    }
    closeSticky(button) {
      button.closest(".sticky--mobile").classList.add("sticky--closed");
    }
    async renderSort(select) {
      let url = new URL(document.URL);
      url.searchParams.set("sort_by", select.value),
        url.searchParams.delete("page");
      let stateURL = url.href,
        container = document.querySelector(
          ".shopify-section.row--product.product__list"
        );
      container.style.opacity = "0.5";
      let { html } = await this.basync.load({
        url,
        section: "product-list",
        selector: "#shopify-section-product-list",
      });
      if (!html) return (container.style.opacity = "1");
      (container.innerHTML = html),
        history.replaceState({}, "", stateURL),
        this.events.trigger("booster:content:update", { trigger: "sort" }),
        (container.style.opacity = "1");
    }
    submitSearch(target) {
      target.closestEl("form").submit();
    }
      openSearch(target){
  
          if(!target){
              target = document.querySelector('.search__container--abs');
              target.classList.add('focused');
              target = target.querySelector('input');
          } else {
              target.closestEl('[data-search-container]').classList.add('focused');
              if(target.tagName != "input"){
              target = target.closestEl('input');
              }
          }
          target.focus();
  
          const searchContainer = document.querySelector('[data-search-container].focused');
          searchContainer.closestEl('input').focus();
  
          let container = target.closestEl('[data-search-suggest]');
          if(!target.value.length){
              boosterTheme.handleEmptySearch(container);
          }
      }
    closeSearch(target) {
      target.closestEl("[data-search-container]").classList.remove("focused");
    }
    renderProductCard(product){
          let card = this.cardTemplate.cloneNode(true).content.children[0];
          const $c = (q)=>card.querySelector(q)
          console.log('add onclick2');
          card.onclick = () => {"console.log('click')"};
          $c('.card__img--container').href = product.url;
          $c('.card__title').href = product.url;
          $c('[data-product-image]').src = product.featured_image.url;
          $c('.card__title').innerText = product.title;
          $c('.card__price').innerText = product.price.toString().replace('.', ',') + ' €';
          let countdown = $c('[data-countdown]');
          countdown.classList.add('hide');
          countdown.removeAttribute('data-countdown');
          if(!product.available){
              card.classList.add('card--soldout');
          }
          //card.classList.add('col-md-1-5');
          return card;
      }
    createSearchSuggestResult(product) {
      return this.renderProductCard(product);
    }
    populateSearchSuggest(container, data) {
      for (
        var products = data.resources.results.products,
          frag = document.createDocumentFragment(),
          i = 0,
          maxi = products.length;
        i < maxi;
        ++i
      )
        products[i].tags.includes("no_search") ||
          frag.appendChild(this.createSearchSuggestResult(products[i]));
      (container.innerHTML = ""), container.appendChild(frag);
      var articles = data.resources.results.articles;
      if (articles.length > 0) {
        var articleContainer = document.createElement("div"),
          articleTitle = document.createElement("h4");
        (articleTitle.innerText = "Articles"),
          (articleTitle.style.marginTop = "0px"),
          articleTitle.classList.add("col-12"),
          articleContainer.append(articleTitle);
        for (
          var articleFrag = document.createDocumentFragment(),
            a = 0,
            a_maxi = articles.length;
          a < a_maxi;
          ++a
        ) {
          const element = document.createElement("a");
          (element.href = articles[a].url),
            (element.innerText = articles[a].title),
            element.classList.add("col-12"),
            articleContainer.appendChild(element);
        }
        container.appendChild(articleContainer);
      }
      var pages = data.resources.results.pages;
      if (pages.length > 0) {
        var pageContainer = document.createElement("div"),
          pageTitle = document.createElement("h4");
        (pageTitle.innerText = "Pages"),
          (pageTitle.style.marginTop = "0px"),
          pageTitle.classList.add("col-12"),
          pageContainer.append(pageTitle);
        for (
          var pageFrag = document.createDocumentFragment(),
            p = 0,
            p_maxi = pages.length;
          p < p_maxi;
          ++p
        ) {
          const element = document.createElement("a");
          (element.href = pages[p].url),
            (element.innerText = pages[p].title),
            element.classList.add("col-12"),
            pageContainer.appendChild(element);
        }
        container.appendChild(pageContainer);
      }
      return this.events.trigger("booster:content:update");
    }
    searchSuggest(event) {
      var self2 = this;
      let query = event.target.value,
        container = event.target
          .closest("[data-search-container]")
          .querySelector("[data-search-suggest]");
      if (query.length > 0) {
        let q = `${window.Shopify.routes.root}search/suggest.json?q=${query}&resources[type]=product,page,article&resources[limit]=5&resources[options][unavailable_products]=last`;
        fetch(q)
          .then((r) => r.json())
          .then((data) => self2.populateSearchSuggest(container, data));
      } else return this.handleEmptySearch(container);
    }
    handleEmptySearch(container) {
      return (
        (container.innerHTML = emptySearch),
        this.events.trigger("booster:content:update")
      );
    }
    async quickBuy(e) {
      if (window.innerWidth < 768) return;
      e.preventDefault();
      const button =
          '<button class="close" onclick="closeModal(event)"><i class="uil uil-arrow-left"></i>' +
          _bstrLocale.buttons.back_to_shop +
          "</button>",
        $e = (e2, q) => e2.querySelector(q);
      let url = new URL(e.target.closest("a").href),
        { parser } = await this.basync.load({
          url,
          section: "product-page__product",
        });
      if (
        $e(parser, ".product__row").classList.contains(
          "product__row--marketplace"
        )
      ) {
        let container = $e(parser, ".product__row");
        container.classList.remove("product__row--marketplace");
        let middle = $e(container, ".product__page--info"),
          title = $e(middle, ".product__title"),
          price = $e(middle, ".product__price--holder");
        container.removeChild(middle);
        let sticky = $e(container, ".product__page--info");
        $e(sticky, ".product__title") ||
          sticky.insertBefore(title, sticky.firstChild),
          $e(sticky, ".product__price") ||
            $e(sticky, ".product__title").insertAdjacentElement(
              "afterend",
              price
            );
      }
      let quickBuy = document.getElementById("quickbuy__modal");
      ($e(quickBuy, ".content").innerHTML =
        button + $e(parser, "body").innerHTML),
        (quickBuy.style.display = "flex"),
        this.events.trigger("booster:content:update", { trigger: "quickbuy" });
    }
    toggleTab(self2, id) {
      let container = self2.closest(".tab__container");
      container.querySelector(".tab--show").classList.remove("tab--show"),
        container.querySelector(`#${id}`).classList.add("tab--show"),
        container
          .querySelector(".tab__holder")
          .querySelector(".tab--active")
          .classList.remove("tab--active"),
        self2.classList.add("tab--active");
    }
    toggleCollectionView(view, target) {
      if (target.classList.contains("view--active")) return;
      target.closestEl(".view--active").classList.remove("view--active"),
        target.classList.add("view--active");
      let rows = document.querySelectorAll(".row--product");
      if (view == "card")
        for (var i = 0, maxi = rows.length; i < maxi; ++i)
          rows[i].classList.remove("card--expanded");
      else
        for (var i = 0, maxi = rows.length; i < maxi; ++i)
          rows[i].classList.add("card--expanded");
    }
    async renderChangePage(e = !1, clickTarget, overwrite = !1) {
      e && e.preventDefault();
      let container = document.querySelector(".product__list.row--product");
      (container.style.opacity = "0.4"), (clickTarget.disabled = !0);
      let url = new URL(clickTarget.href),
        { html } = await this.basync.load({
          url,
          selector: ".product__list.row--product",
        });
      if (!html)
        return (container.style.opacity = "1"), (clickTarget.disabled = !1);
      overwrite
        ? ((container.innerHTML = html),
          container.scrollIntoView({ block: "start", behavior: "smooth" }))
        : (clickTarget.closest(".pagination").remove(),
          (container.innerHTML += html)),
        (this.rendering = !1);
      let stateURL = new URL(document.URL);
      return (
        stateURL.searchParams.set("page", url.searchParams.get("page")),
        history.pushState({}, "", stateURL),
        (container.style.opacity = "1"),
        this.events.trigger("booster:content:update", { trigger: "pagination" })
      );
    }
    localizeDates() {
      let dates = document.querySelectorAll(
        "[data-bstr-delivery-date]:not([data-bstr-initd])"
      );
      for (let date of dates) {
        date.dataset.bstrInitd = "true";
        let n = parseInt(date.innerText.replace(/[^\d]/g, ""));
        if (isNaN(n)) continue;
        let cdate = new Date();
        cdate.setDate(cdate.getDate() + n);
        const options = {
          weekday: "short",
          year: "numeric",
          month: "short",
          day: "2-digit",
        };
        date.innerText = cdate.toLocaleDateString(`${Shopify.locale}`, options);
      }
    }
  }
  class BstrFilters {
    constructor({ events: events2, basync }) {
      (this.basync = basync),
        (this.events = events2),
        this.initListeners(),
        this.events.on("booster:content:update", () => this.initListeners());
    }
    initListeners() {
      for (let e of document.querySelectorAll(
        "input[data-filter-href]:not([data-bstr-initd])"
      ))
        (e.dataset.bstrInitd = "true"),
          e.addEventListener("change", this.modifyFilters.bind(this));
      for (let e of document.querySelectorAll(
        "[data-filter-href]:not([data-bstr-initd]):not(input)"
      ))
        (e.dataset.bstrInitd = "true"),
          e.addEventListener("click", this.modifyFilters.bind(this));
    }
    modifyFilters(event) {
      this.renderChangePage(event.target.dataset.filterHref);
      let selectedProductCount = 0,
        currentFilterCount = 0,
        hasSelectedFilter = 0;
      document.querySelectorAll("[data-filter-href]").forEach((value) => {
        const productCount = Number(
          value.nextElementSibling.querySelector("[data-filter-count]").innerHTML
        );
        value.checked &&
          (hasSelectedFilter++, (selectedProductCount += productCount)),
          (currentFilterCount += productCount);
      }),
        hasSelectedFilter
          ? (document.querySelector(".filter__mobile--current").innerText =
              selectedProductCount)
          : (document.querySelector(".filter__mobile--current").innerText =
              currentFilterCount);
    }
    setInputState(state) {
      for (let e of document.querySelectorAll("[data-filter-href]"))
        e.disabled = !state;
    }
    async renderChangePage(href) {
      let container = document.querySelector(
        ".shopify-section.row--product.product__list"
      );
      (container.style.opacity = "0.4"), this.setInputState(!1);
      let url = new URL(window.location.origin + href),
        { html, json } = await this.basync.load({
          url,
          section: "product-list",
          selector: "#shopify-section-product-list",
          json: "noscript",
        });
      if (!html) {
        this.setInputState(!0), (container.style.opacity = "1");
        return;
      }
      (container.innerHTML = html),
        history.pushState({}, "", window.location.origin + href),
        this.events.trigger("booster:content:update"),
        (container.style.opacity = "1"),
        this.renderFilters(json);
      for (let c of document.querySelectorAll(".collection__total-items"))
        c.innerText = json.count;
    }
    renderFilters(json) {
      this.setInputState(!0);
      for (let [k, v] of Object.entries(json.filters))
        for (let f of v) {
          let t = document.querySelector(`[data-filter="${k}-${f.value}"]`),
            c = t.nextElementSibling.querySelector("[data-filter-count]");
          c && (c.innerText = f.count),
            (t.disabled = !f.count),
            (t.checked = f.active),
            (t.dataset.filterHref = f.active ? f.urls.remove : f.urls.add),
            f.count
              ? t.closest("div").classList.remove("filter--disabled")
              : t.closest("div").classList.add("filter--disabled");
        }
    }
  }
  class BstrGDPR {
    constructor(id = "bstr--notice") {
      (this.container = document.getElementById(id)),
        this.container &&
          ((this.closeButton =
            this.container.querySelector("[data-gdpr-accept]")),
          this.closeButton &&
            this.closeButton.addEventListener("click", this.close.bind(this)),
          this.open(!0));
    }
    open(check = !1) {
      if (!this.container)
        return console.info("[OPEN] GDPR container not found.");
      if (!(check && bstore.get("bstr_gdpr")))
        return (this.container.style.display = "block");
    }
    close() {
      return this.container
        ? (bstore.set("bstr_gdpr", "true", 43200),
          (this.container.style.display = "none"))
        : console.info("[CLOSE] GDPR container not found.");
    }
  }
  class BstrEvents {
    constructor() {
      (this.listeners = {}), (this.logs = {});
    }
    on(event, cb) {
      if (typeof cb != "function")
        throw "[BOOSTER EVENT] Callback must be a function. Event: " + event;
      this.logs[event] && cb.call(cb, this.logs[event]),
        typeof this.listeners[event] > "u"
          ? (this.listeners[event] = [cb])
          : this.listeners[event].push(cb);
    }
    trigger(event, params = {}, log = !1) {
      let cbs = this.listeners[event],
        dom_prevented = document.dispatchEvent(
          new CustomEvent(event, {
            detail: params,
            cancelable: event.includes(":b*"),
            bubbles: !0,
          })
        ),
        rs = [dom_prevented];
      if (cbs && cbs.length) {
        let prevented = !dom_prevented;
        for (let cb of cbs)
          try {
            let r = cb.call(cb, { ...params, prevented });
            typeof r < "u" &&
              (rs.push(r), prevented !== !0 && (prevented = r === !1));
          } catch (err) {
            console.info(`[BOOSTER EVENTS] Error caught on ${event}.
  ${err}`);
            continue;
          }
      }
      return (
        log && (this.logs[event] = params),
        { values: rs, prevent: rs.includes(!1) }
      );
    }
  }
  class BstrIU {
    constructor({ cfx, events: events2, swatches }) {
      (this.cfx = cfx),
        (this.swatches = swatches),
        (this.events = events2),
        this.events.on("booster:variant:select", this.syncInputs.bind(this));
    }
    syncInputs(params) {
      if (!params.selectedVariant.available) return;
      let pid = params.product.id,
        vid = params.selectedVariant.id;
      document.querySelectorAll(`[data-upsell-id="${pid}"]`).forEach((e) => {
        e.tagName == "SELECT" && e.value != vid && (e.value = vid);
      }),
        this.toggleVariantIU();
    }
    toggleVariantIU(elem = !1) {
      let total = document.getElementById("inline-upsell__total");
      if (!total) return;
      let stotal = document.getElementById("inline-upsell__discount");
      if (elem && elem.tagName == "SELECT") {
        let id = elem.dataset.upsellId,
          variant = elem.value;
        this.swatches.setProductVariant(id, variant);
      }
      let selected = document.querySelectorAll(
          "input.inline-upsell__toggle:checked"
        ),
        price = 0,
        compare = 0,
        elements = [],
        format = this.cfx.getFormat(Shopify.currency.active);
      for (let i = 0, maxi = selected.length; i < maxi; ++i) {
        let input = document.getElementById(selected[i].dataset.for),
          pprice =
            input.tagName == "INPUT"
              ? parseInt(input.dataset.price)
              : parseInt(input.options[input.selectedIndex].dataset.price),
          sprice =
            input.tagName == "INPUT"
              ? parseInt(input.dataset.comparePrice)
              : parseInt(input.options[input.selectedIndex].dataset.comparePrice),
          card = input.closestEl(".card--default"),
          cpprice = card.querySelector("[data-iu-price]"),
          csprice = card.querySelector("[data-iu-price-sale]");
        (cpprice.innerHTML = this.cfx.formatMoney(pprice, format)),
          elements.push(cpprice),
          sprice > pprice
            ? (csprice.parentElement.classList.add("card__price--sale"),
              (csprice.innerHTML = this.cfx.formatMoney(sprice, format)),
              elements.push(csprice))
            : (csprice.parentElement.classList.remove("card__price--sale"),
              (csprice.innerHTML = "")),
          (price += pprice),
          (compare += sprice);
      }
      (total.innerHTML = this.cfx.formatMoney(price, format)),
        (stotal.innerHTML =
          compare > price ? this.cfx.formatMoney(compare, format) : ""),
        elements.push(total, stotal),
        this.events.trigger("booster:price:update", {
          currency: Shopify.currency.active,
          elements,
        });
    }
  }
  class BstrLazy {
    constructor({ events: events2, cname = "lazyload" }) {
      (this.events = events2),
        (this.class = cname),
        (this.images = !0),
        "loading" in HTMLImageElement.prototype &&
          _settings.nativeLazyLoad &&
          (this.images = !1),
        this.init();
    }
    init() {
      this.images || this.convertNative(),
        (this.observer = new IntersectionObserver(
          function (entries, self2) {
            for (let i = 0, maxi = entries.length; i < maxi; ++i) {
              let entry = entries[i];
              if (entry.isIntersecting) {
                let t = entry.target;
                switch (
                  (t.classList.remove("lazyload"),
                  t.classList.add("lazyloaded"),
                  t.tagName)
                ) {
                  case "IMG":
                    t.dataset.sizes && (t.sizes = t.dataset.sizes),
                      t.dataset.src && (t.src = t.dataset.src),
                      t.dataset.srcset && (t.srcset = t.dataset.srcset);
                    break;
                  case "DIV":
                    if (t.dataset.bgset) {
                      let width = window.innerWidth,
                        bgset = t.dataset.bgset.split(",");
                      for (let i2 = 0, maxi2 = bgset.length; i2 < maxi2; ++i2) {
                        let bg = bgset[i2].split(" ");
                        if (parseInt(bg[1]) >= width || i2 + 1 == bgset.length) {
                          t.style.backgroundImage = `url(${bg})`;
                          break;
                        }
                      }
                      break;
                    }
                    t.src = t.dataset.src;
                    break;
                  case "VIDEO":
                    let v = t.querySelector("source");
                    v.src = v.dataset.src;
                    break;
                  default:
                    t.src = t.dataset.src;
                    break;
                }
                self2.unobserve(entry.target);
              }
            }
          },
          { threshold: 0.05 }
        ));
      let lazyloads = this.images
        ? document.querySelectorAll(".lazyload")
        : document.querySelectorAll('.lazyload:not([loading="lazy"])');
      for (let i = 0, maxi = lazyloads.length; i < maxi; ++i)
        this.observer.observe(lazyloads[i]);
      this.events.on("booster:content:update", () => this.update());
    }
    convertNative() {
      var images = document.querySelectorAll(
        'img[loading="lazy"]:not([data-bstr-initd])'
      );
      for (let i = 0, maxi = images.length; i < maxi; ++i) {
        let t = images[i];
        t.dataset.sizes && (t.sizes = t.dataset.sizes),
          t.dataset.src && (t.src = t.dataset.src),
          t.dataset.srcset && (t.srcset = t.dataset.srcset),
          (t.dataset.bstrInitd = "true");
      }
    }
    update() {
      this.images || this.convertNative();
      let lazyloads = this.images
        ? document.querySelectorAll(".lazyload")
        : document.querySelectorAll('.lazyload:not([loading="lazy"])');
      for (let i = 0, maxi = lazyloads.length; i < maxi; ++i)
        this.observer.observe(lazyloads[i]);
    }
  }
  class BstrNotify {
    constructor({ events: events2 }) {
      (this.events = events2),
        (this.popupHolder = document.getElementById("booster__popup--holder")),
        this.events.on("booster:notify", this.fn.bind(this));
    }
    fn(data) {
      var self2 = this,
        popup;
      data.url
        ? ((popup = document.createElement("a")),
          (popup.href = data.url),
          (popup.target = "_blank"))
        : (popup = document.createElement("div")),
        data.id && (popup.dataset.id = data.id);
      const removeThisFn = function () {
        if (this.dataset.id) {
          let notifs = bstore.get("bstr_notifs") || {},
            dismissed = notifs.dismissed || [];
          dismissed.push(this.dataset.id),
            (notifs.dismissed = dismissed),
            bstore.set("bstr_notifs", notifs, 120);
        }
        this.parentElement.removeChild(this);
      };
      let message = data.message;
      if (typeof message != "string") {
        message =
          (message && (message.description || message.message)) ||
          JSON.stringify(message);
      }
      if (typeof message == "string") {
        try {
          if (message.trim().charAt(0) == "{") {
            let parsed = JSON.parse(message);
            message = parsed.description || parsed.message || message;
          }
        } catch (e) {}
        let lower = message.toLowerCase();
        (lower.includes("no more items in stock") ||
          lower.includes("not enough") ||
          lower.includes("sold out") ||
          lower.includes("inventory") ||
          lower.includes("stock")) &&
          (message = "Die gewünschte Menge ist nicht verfügbar.");
      }
      popup.setAttribute("class", "booster__popup booster__popup--" + data.type),
        (popup.innerText = message),
        self2.popupHolder.appendChild(popup),
        (popup.onclick = removeThisFn),
        popup.classList.add("anim__fade-in"),
        data.expires !== !1 &&
          setTimeout(function () {
            try {
              self2.popupHolder.removeChild(popup);
            } catch {}
          }, data.expires || 5e3);
    }
  }
  class BstrRecentlyBought {
    constructor() {
      typeof recentlyBoughtConfig > "u" ||
        ((this.config = recentlyBoughtConfig),
        (this.container = document.getElementById("recently-bought--holder")),
        this.init());
    }
    async init() {
      let raw = await (
          await fetch(
            this.config.allProductsUrl + "?section_id=api__recently-bought"
          )
        ).text(),
        parser = document.createElement("div");
      parser.innerHTML = raw;
      let parsed = JSON.parse(parser.querySelector(".shopify-section").innerText);
      (parsed.names = parsed.names.split(",")),
        (parsed.names = parsed.names.filter((name) => name.trim() != "")),
        parsed.names.length ||
          (parsed.names =
            "Alissa Ashford, Carroll Calley, Augustina Angulo, Kenna Kuntz, Hailey Hinkle, Breann Beckham, Raquel Roles, Bernetta Beeks".split(
              ","
            )),
        (this.recentlyBoughtCollection = parsed),
        setInterval(
          () => this.render(),
          (_settings.recentlyBoughtInterval + _settings.recentlyBoughtRemain) *
            1e3
        );
    }
    render() {
      const RBC = this.container,
        $rb = (q) => RBC.querySelector(q);
      let img = $rb(".recently-bought--img img"),
        person = $rb(".recently-bought--who"),
        time = $rb(".recently-bought--when"),
        title = $rb(".recently-bought--what"),
        price = $rb(".recently-bought--price"),
        names = this.recentlyBoughtCollection.names,
        products = this.recentlyBoughtCollection.collection,
        product = products[getRandomInt(0, products.length - 1)],
        name;
      if (this.config.useNames)
        if (
          ((name = names[getRandomInt(0, names.length - 1)].trim()),
          this.config.nameFormat == "shorten")
        ) {
          let sname = name.split(" ");
          name = sname.length == 1 ? sname[0] : `${sname[0]} ${sname[1][0]}.`;
        } else
          this.config.nameFormat == "initials" &&
            (name = name
              .split(" ")
              .reduce((n, e) => ((n += `${e[0]}. `), n), ""));
      else name = _bstrLocale.recentlyBought.someone;
      (img.src = product.image),
        (title.innerText = product.title.slice(0, 24)),
        (price.querySelector(".current-price").innerText = product.priceFormat),
        (price.querySelector(".old-price").innerText = product.sale
          ? product.discountPriceFormat
          : ""),
        (person.innerText = _bstrLocale.recentlyBought.purchased.replace(
          "%name%",
          name
        )),
        (time.innerText = _bstrLocale.recentlyBought.ago.replace(
          "%time%",
          getRandomInt(2, 50)
        )),
        (RBC.href = product.url);
      const image_ratio = $rb(".recently-bought--img-ratio");
      image_ratio.dataset.widthAdjusted ||
        ((image_ratio.style.width = RBC.clientHeight + "px"),
        (image_ratio.dataset.widthAdjusted = "true")),
        RBC.classList.add("anim__fade-in"),
        setTimeout(() => {
          RBC.classList.remove("anim__fade-in");
        }, _settings.recentlyBoughtRemain * 1e3);
    }
  }
  class BstrSlider {
    constructor({ events: events2, selector, breakpoints } = {}) {
      (this._selector = selector || "[data-bstr-slider]"),
        (this._idSelector = this._selector
          .replace(/(\[data-|\])/g, "")
          .replace(/-(\w)/g, (s) => s[1].toUpperCase())),
        (this._breakpoints = breakpoints || { sm: 768, md: 1024 }),
        (this._sliders = {}),
        (this._currentIndex = 0),
        (this._resize = !1),
        this.init(),
        events2.on("booster:content:update", () => this.init());
    }
    _isVisible(s_rect, c_rect, vertical) {
      return vertical
        ? c_rect.top - s_rect.top <= 0 && c_rect.bottom - s_rect.bottom >= 0
        : c_rect.left - s_rect.left <= 0 && c_rect.right - s_rect.right >= 0;
    }
    async _parentMoveCallback(slider) {
      let previous = parseInt(slider.dataset.bstrSliderCurrent);
      const vertical =
        slider.dataset.bstrSliderOrientation.toLowerCase() == "vertical";
      if (!slider.querySelector("[data-bstr-slide]")) return;
      let current = Math.round(
        vertical
          ? slider.scrollTop /
              slider.querySelector("[data-bstr-slide]").offsetHeight
          : slider.scrollLeft /
              slider.querySelector("[data-bstr-slide]").offsetWidth
      );
      slider.dataset.bstrSliderCurrent = current;
      let direction = previous - current > 0 ? "+" : "-",
        s_children = slider.querySelectorAll("[data-bstr-slide]"),
        parray = [],
        carray = [];
      const s_rect = slider
        .closest("[data-bstr-slide-holder]")
        .getBoundingClientRect();
      for (let i = 0; i < s_children.length; ++i) {
        let child = s_children[i];
        this._isVisible(s_rect, child.getBoundingClientRect(), vertical)
          ? ((child.dataset.bstrSlide = "active"),
            carray.push({ index: i, target: child }))
          : child.dataset.bstrSlide == "active" &&
            ((child.dataset.bstrSlide = ""),
            parray.push({ index: i, target: child }));
      }
      this._moveCallback &&
        this._moveCallback({
          direction,
          slider,
          current: carray,
          previous: parray,
        });
    }
    init(selector = !1) {
      let slideScroll = document.querySelector(".slider--product-holder");
      slideScroll && slideScroll.classList.add("slide-scroll");
      let sliders = document.querySelectorAll(
        `${selector || this._selector}:not([data-bstr-initd])`
      );
      for (let sliderComponent of sliders) {
        let slider = sliderComponent.querySelector("[data-bstr-slide-holder]"),
          id;
        sliderComponent.dataset[this._idSelector]
          ? (id = sliderComponent.dataset[this._idSelector])
          : ((id = ++this._currentIndex),
            (sliderComponent.dataset[this._idSelector] = id)),
          sliderComponent.setAttribute("data-bstr-initd", "true"),
          (slider.dataset.bstrSliderId = id);
        let viewports = slider.dataset.bstrSlideHolder.split("|");
        if (viewports.length == 3)
          this._sliders[id] = {
            lg: parseInt(viewports[0]),
            md: parseInt(viewports[1]),
            sm: parseInt(viewports[2]),
          };
        else {
          let parsed = parseInt(viewports[0]);
          this._sliders[id] = isNaN(parsed)
            ? { lg: 1, md: 1, sm: 1 }
            : { lg: parsed, md: parsed, sm: parsed };
        }
        let buttons = [
          ...sliderComponent.querySelectorAll("[data-bstr-slider-button]"),
          ...document.querySelectorAll(
            `[data-bstr-slider-button][data-bstr-for-slider="${id}"]`
          ),
        ];
        for (let button of buttons)
          button.addEventListener("click", (e) => {
            e.preventDefault(),
              e.stopImmediatePropagation(),
              this._move({
                slider,
                direction: button.dataset.bstrSliderButton || "+",
              });
          });
        if (slider.dataset.bstrAutoplay == "true") {
          const slideSpeed = slider.dataset.bstrSlideSpeed;
          this._autoplayHandler({ slider, slideSpeed });
        }
        this._parentMoveCallback(slider),
          slider.addEventListener(
            "scroll",
            debounce(() => this._parentMoveCallback(slider), 100),
            { passive: !0 }
          );
      }
      this._resize ||
        (this._resizeHandler(),
        window.addEventListener(
          "resize",
          debounce(this._resizeHandler.bind(this), 250),
          { passive: !0 }
        ),
        (this._resize = !0));
    }
    _autoplayHandler({ slider, slideSpeed }) {
      setInterval(() => {
        this._move({ slider, direction: "+" });
      }, slideSpeed);
    }
    _resizeHandler() {
      window.innerWidth < this._breakpoints.sm
        ? (this.viewport = "sm")
        : window.innerWidth < this._breakpoints.md
        ? (this.viewport = "md")
        : (this.viewport = "lg"),
        (this.rawViewport = window.innerWidth);
    }
    _moveTo({ index = 0, slider }) {
      let current = parseInt(slider.dataset.bstrSliderCurrent),
        vertical =
          slider.dataset.bstrSliderOrientation.toLowerCase() == "vertical",
        s_children = slider.querySelectorAll("[data-bstr-slide]");
      s_children.length &&
        ((current = Math.max(Math.min(index, s_children.length - 1), 0)),
        vertical
          ? slider.scrollTo(0, s_children[current].offsetTop - slider.offsetTop)
          : slider.scrollTo(
              s_children[current].offsetLeft -
                slider.offsetLeft -
                parseInt(window.getComputedStyle(slider).paddingLeft),
              0
            ));
    }
    _moveThumbTo({ index = 0 }) {
      const width = screen.width,
        target = document.querySelector(`[data-bstr-slider-thumb='${index}']`);
      width > 767
        ? (target.parentNode.scrollTop = target.offsetTop)
        : (target.parentNode.scrollLeft = target.offsetLeft);
    }
    _move({ direction, slider }) {
      let moveBy = this._sliders[slider.dataset.bstrSliderId][this.viewport],
          current = parseInt(slider.dataset.bstrSliderCurrent),
          previous = current,
          vertical =
            slider.dataset.bstrSliderOrientation.toLowerCase() == "vertical",
          s_children = slider.querySelectorAll("[data-bstr-slide]");
      if (!s_children.length) return;
  
      let offset = Math.round(
        vertical
          ? 1 / (s_children[0].offsetHeight / slider.offsetHeight)
          : 1 /
              (s_children[0].offsetWidth /
                (slider.offsetWidth -
                  parseInt(window.getComputedStyle(slider).paddingLeft)))
      );
  
      current =
        direction === "+"
          ? Math.min(current + moveBy, s_children.length - offset)
          : Math.max(current - moveBy, 0);
  
      if (slider.dataset.bstrSlideLoop && current === previous) {
        current = direction === "-" ? s_children.length - offset : 0;
      }
  
      // ✅ Fix: actually move the slider
      this._moveTo({ index: current, slider });
    }
  }
  class ProductSlider extends BstrSlider {
    constructor(props) {
      super(props),
        this.initThumbs(),
        props.events.on("booster:content:update", this.initThumbs);
    }
    initThumbs() {
      let thumbs = document.querySelectorAll(
        "[data-bstr-slider-thumb]:not([data-bstr-initd])"
      );
      for (let thumb of thumbs) {
        let sid = thumb.dataset.bstrSliderFor,
          slider = sid
            ? document.querySelector(
                `[data-bstr-ppslider="${sid}"] [data-bstr-slide-holder]`
              )
            : thumb.closest("[data-bstr-ppslider]"),
          index = parseInt(thumb.dataset.bstrSliderThumb);
        thumb.addEventListener("click", () => super._moveTo({ slider, index })),
          thumb.getAttribute("data-bstr-slider-thumb-hover") != null &&
            thumb.addEventListener("mouseover", () =>
              super._moveTo({ slider, index })
            );
      }
    }
    _moveCallback({ slider, current }) {
      if (!current.length) return;
      let id = slider.dataset.bstrSliderId;
      for (let th of document.querySelectorAll(
        `.bstrSlider__thumb--active[data-bstr-slider-for="${id}"]`
      ))
        th.classList.remove("bstrSlider__thumb--active");
      if (window.innerWidth < 790) {
        let max = 0;
        for (let c of current) {
          let ch = c.target.children[0];
          ch && ch.clientHeight > max && (max = ch.clientHeight);
        }
        max &&
          (slider.closest("[data-bstr-ppslider]").style.maxHeight = `${max}px`);
      } else slider.closest("[data-bstr-ppslider]").style.maxHeight = null;
      document
        .querySelector(
          `[data-bstr-slider-thumb="${current[0].index}"][data-bstr-slider-for="${id}"]`
        )
        .classList.add("bstrSlider__thumb--active");
    }
  }
  class BstrSectionSlider extends BstrSlider {
    constructor(props) {
      super(props);
    }
    _moveCallback(params) {
      for (let { target } of params.previous) {
        let slide =
          target.dataset.type == "bannerSlider"
            ? target.querySelector("div")
            : target;
        slide.dataset.type == "video" && slide.querySelector("video").pause(),
          slide.classList.remove("slide__animation");
      }
      for (let { target } of params.current) {
        let slide =
          target.dataset.type == "bannerSlider"
            ? target.querySelector("div")
            : target;
        slide.dataset.type == "video" && slide.querySelector("video").play(),
          slide.classList.add("slide__animation");
      }
    }
  }
  class BstrStock {
    constructor({ events: events2 }) {
      (this.events = events2),
        this.stockInterval,
        this.initStock(),
        this.events.on("booster:content:update", this.initStock.bind(this));
    }
    async initStock() {
      this.stockInterval && clearInterval(this.stockInterval);
      let holders = document.querySelectorAll("[data-stock-type]");
      if (!holders.length) return;
      let cookie = bstore.get("bstrStock") || {},
        managed = [],
        reduce = parseInt(holders[0].dataset.reduce);
      (holders[0].dataset.stockType == "inventory" ||
        cookie.stockInfo != holders[0].dataset.stockType) &&
        (cookie = { stockInfo: holders[0].dataset.stockType });
      for (let i = 0, maxi = holders.length; i < maxi; ++i) {
        let item = holders[i],
          stock;
        if (
          (cookie[item.dataset.product]
            ? ((stock = cookie[item.dataset.product]), managed.push(item))
            : item.dataset.stockType == "inventory"
            ? (stock = item.dataset.stockLeft)
            : ((stock = getRandomInt(
                item.dataset.stockLeft / 10,
                item.dataset.stockLeft
              )),
              (cookie[item.dataset.product] = stock),
              managed.push(item)),
          item.dataset.stockType == "inventory")
        )
          item.closestEl(".amount--left").style.width = getRandomInt(5, 25) + "%";
        else {
          let width = Math.floor((stock / item.dataset.stockLeft) * 100 * 0.25);
          width < 5 && (width = 5),
            (item.closestEl(".amount--left").style.width = width + "%");
        }
        item.innerText = stock;
      }
      if ((bstore.set("bstrStock", cookie, 1440), reduce > 0)) {
        var self2 = this;
        this.stockInterval = setInterval(() => {
          self2.stockManagement(managed);
        }, reduce * 1e3);
      }
    }
    stockManagement(holders) {
      let cookie = bstore.get("bstrStock") || {};
      for (let i = 0, maxi = holders.length; i < maxi; ++i) {
        let item = holders[i],
          stock = parseInt(item.innerText);
        stock > 1 && --stock, (cookie[item.dataset.product] = stock);
        let width = Math.floor((stock / item.dataset.stockLeft) * 100 * 0.25);
        width < 5 && (width = 5),
          (item.closestEl(".amount--left").style.width = width + "%"),
          (item.innerText = stock);
      }
      bstore.set("bstrStock", cookie, 1440);
    }
  }
  class BstrSwatches {
    constructor({ events: events2, slider, cfx }) {
      (this.events = events2),
        (this.current = {}),
        (this.variants = {}),
        (this.THEME_UTILS = new BstrSwatchesTheme({
          swatches: this,
          events: events2,
          slider,
          cfx,
        })),
        this.initListeners(),
        this.events.on("booster:content:update", () => {
          this.initListeners();
          for (let k of Object.keys(this.current)) this.filterSwatches(k);
        });
    }
    initListeners() {
      const self2 = this;
      let swatches = document.querySelectorAll(
        "[data-swatch-index]:not([data-booster-initd])"
      );
      for (let swatch of swatches)
        swatch.tagName != "OPTION" &&
          (swatch.tagName === "SELECT"
            ? swatch.addEventListener("change", (event) => {
                let t = event.currentTarget,
                  v = t.value,
                  pi = t.dataset.swatchIndex.trim().split("-"),
                  swatchOption;
                v === "bstrSelectNill" ? (swatchOption = !1) : (swatchOption = v),
                  self2.setOption(pi[0], parseInt(pi[1]), swatchOption);
              })
            : swatch.addEventListener("click", (event) => {
                let t = event.currentTarget;
                if (
                  (_settings.swatchLogic != "amazon" &&
                    t.classList.contains("swatch--disabled")) ||
                  (_settings.disableSOSwatch && t.dataset.swatchSoldout)
                )
                  return;
                let pi = t.dataset.swatchIndex.trim().split("-"),
                  swatchOption;
                t.classList.contains("swatch--active")
                  ? (swatchOption = !1)
                  : (swatchOption = swatch.dataset.swatchOption),
                  self2.setOption(pi[0], parseInt(pi[1]), swatchOption);
              }),
          (swatch.dataset.boosterInitd = "true"));
      if (_settings.preselectSwatch != "false") {
        let variants = document.querySelectorAll(
          "noscript[data-bstr-preselect]:not(data-bstr-initd)"
        );
        if (_settings.preselectSwatch == "firstOptionIndex")
          for (let nos of variants)
            (nos.dataset.bstrInitd = "true"),
              !Object.keys(this.current).includes(nos.dataset.bstrSwatch) &&
                this.setOption(
                  nos.dataset.bstrSwatch,
                  0,
                  this.getVariant(
                    nos.dataset.bstrSwatch,
                    nos.dataset.bstrPreselect
                  ).options[0]
                );
        else
          for (let nos of variants)
            (nos.dataset.bstrInitd = "true"),
              !Object.keys(this.current).includes(nos.dataset.bstrSwatch) &&
                this.setProductVariant(
                  nos.dataset.bstrSwatch,
                  nos.dataset.bstrPreselect
                );
      }
    }
    getVariants(pid) {
      return (
        this.variants[pid] ||
          (this.variants[pid] = JSON.parse(
            document.querySelector(`noscript[data-bstr-swatch="${pid}"]`)
              .innerText
          )),
        this.variants[pid]
      );
    }
    getVariant(pid, id) {
      return this.getVariants(pid)[id];
    }
    findVariant(pid) {
      const current = this.current[pid],
        variants = this.getVariants(pid);
      for (let [k, v] of Object.entries(variants)) {
        let f = !0;
        for (let i = 0; i < current.length; ++i)
          if (current[i] !== !1 && v.options[i] !== current[i]) {
            f = !1;
            break;
          }
        if (f) return k;
      }
      return !1;
    }
    dropCombination(pid, idx) {
      const variants = this.getVariants(pid),
        v_values = Object.values(variants),
        current = [...this.current[pid]];
      let aoptions = this.genArray(() => [], 0, current.length),
        nidx;
      for (let i = 0; i < current.length; ++i)
        if (!(current[i] === !1 || i === idx)) {
          nidx = i;
          break;
        }
      for (let { options } of v_values)
        if (options[idx] == current[idx])
          for (let j = 0; j < options.length; ++j) aoptions[j].push(options[j]);
      for (let i = 0; i < aoptions.length; ++i)
        i !== idx &&
          (aoptions[i].includes(this.current[pid][i]) ||
            (this.current[pid][i] = !1));
      if (
        JSON.stringify(current) === JSON.stringify(this.current[pid]) &&
        ((this.current[pid][nidx] = !1), !this.findVariant(pid))
      )
        return this.dropCombination(pid, idx);
    }
    validateOptions(pid, changeOptions, i) {
      let ov = this.findVariant(pid),
        selected = !1;
      typeof ov != "boolean" && (selected = ov),
        (this.current[pid] = changeOptions);
      let mv = this.findVariant(pid);
      mv === !1
        ? (_settings.swatchLogic === "amazon" && this.dropCombination(pid, i),
          this.events.trigger("booster:swatch:update", {
            selectedVariant: !1,
            currentOptions: this.current[pid],
            product: { id: pid, variants: this.getVariants(pid) },
          }),
          selected !== !1 &&
            this.events.trigger("booster:variant:deselect", {
              oldVariant: selected,
              currentOptions: this.current[pid],
              product: { id: pid, variants: this.getVariants(pid) },
            }))
        : this.current[pid].includes(!1)
        ? (this.events.trigger("booster:swatch:update", {
            selectedVariant: !1,
            currentOptions: this.current[pid],
            product: { id: pid, variants: this.getVariants(pid) },
          }),
          selected !== !1 &&
            this.events.trigger("booster:variant:deselect", {
              oldVariant: selected,
              currentOptions: this.current[pid],
              product: { id: pid, variants: this.getVariants(pid) },
            }))
        : (this.events.trigger("booster:swatch:update", {
            selectedVariant: this.getVariant(pid, mv),
            currentOptions: this.current[pid],
            product: { id: pid, variants: this.getVariants(pid) },
          }),
          this.events.trigger("booster:variant:select", {
            selectedVariant: this.getVariant(pid, mv),
            currentOptions: this.current[pid],
            product: { id: pid, variants: this.getVariants(pid) },
          })),
        this.filterSwatches(pid);
    }
    setOption(pid, i, o) {
      this.current[pid] ||
        (this.current[pid] = new Array(
          Object.values(this.getVariants(pid))[0].options.length
        ).fill(!1));
      let changeOptions = [...this.current[pid]];
      (changeOptions[i] = o), this.validateOptions(pid, changeOptions, i);
    }
    setOptions(pid, arr) {
      this.current[pid] ||
        (this.current[pid] = new Array(
          Object.values(this.getVariants(pid))[0].options.length
        ).fill(!1)),
        this.validateOptions(pid, [...arr], 0);
    }
    setProductVariant(pid, id) {
      const variant = this.getVariant(pid, id);
      this.setOptions(pid, variant.options);
    }
    genArray(gf, s, e) {
      let a = [];
      for (let i = s; i < e; ++i) a[i] = gf.call();
      return a;
    }
    matchesOptions(c, options) {
      for (let i = 0; i < options.length; ++i)
        if (c[i] !== !1 && c[i] != options[i]) return !1;
      return !0;
    }
    filterSwatches(pid) {
      const variants = this.getVariants(pid),
        current = this.current[pid];
      let aVars = current.length,
        aOptions = this.genArray(() => new Set(), 0, aVars);
      for (let v of Object.values(variants))
        for (let i = 0; i < aVars; ++i) aOptions[i].add(v.options[i]);
      for (let i = 0; i < current.length; ++i) {
        let tOpts = this.genArray(() => new Set(), 0, aVars),
          cm = [...current];
        cm[i] = !1;
        for (let { options } of Object.values(variants))
          if (this.matchesOptions(cm, options))
            for (let j = 0; j < aVars; ++j) tOpts[j].add(options[j]);
        aOptions[i] = new Set([...aOptions[i]].filter((v) => tOpts[i].has(v)));
      }
      return this.events.trigger("booster:swatch:render", {
        pid,
        options: current,
        aOptions,
      });
    }
  }
  class BstrSwatchesTheme {
    constructor({ swatches, events: events2, slider, cfx }) {
      (this.sw = swatches),
        (this.cfx = cfx),
        (this.slider = slider),
        (this.events = events2),
        this.initEvents();
    }
    initEvents() {
      this.events.on("booster:variant:select", this.selectSwatch.bind(this)),
        this.events.on(
          "booster:variant:deselect",
          this.deselectSwatch.bind(this)
        ),
        _settings.variantShowImage &&
          this.events.on("booster:swatch:update", this.scrollToImage.bind(this)),
        this.events.on("booster:swatch:render", this.renderSwatches.bind(this));
    }
    renderSwatches({ pid, options, aOptions }) {
      for (let i = 0; i < aOptions.length; ++i) {
        let os = document.querySelectorAll(`[data-swatch-index="${pid}-${i}"]`);
        for (let o of os)
          o.tagName == "OPTION"
            ? aOptions[i].has(o.value)
              ? o.removeAttribute("disabled")
              : o.setAttribute("disabled", "true")
            : o.tagName !== "SELECT" &&
              (aOptions[i].has(o.dataset.swatchOption)
                ? o.classList.remove("swatch--disabled")
                : o.classList.add("swatch--disabled"));
      }
      for (let e of document.querySelectorAll(
        `.swatch--active[data-swatch-index^="${pid}"]`
      ))
        e.classList.remove("swatch--active");
      for (let i = 0; i < options.length; ++i)
        options[i] === !1
          ? (document
              .querySelectorAll(`span[data-swatch-selected-name="${pid}-${i}"]`)
              .forEach((e) => (e.innerText = "")),
            document
              .querySelectorAll(`select[data-swatch-index="${pid}-${i}"]`)
              .forEach((e) => (e.value = "bstrSelectNill")))
          : document
              .querySelectorAll(`span[data-swatch-selected-name="${pid}-${i}"]`)
              .forEach((e) => (e.innerText = " - " + options[i]));
      let actives = [];
      for (let i = 0; i < options.length; ++i)
        options[i] !== !1 &&
          (actives.push(
            ...document.querySelectorAll(
              `[data-swatch-option="${CSS.escape(
                options[i]
              )}"][data-swatch-index="${pid}-${i}"]`
            )
          ),
          actives.push(
            ...document.querySelectorAll(
              `option[value="${CSS.escape(
                options[i]
              )}"][data-swatch-index="${pid}-${i}"]`
            )
          ));
      for (let e of actives)
        e.tagName == "OPTION"
          ? (e.closest("select").value = e.value)
          : e.classList.add("swatch--active");
    }
    scrollToImage(params) {
      let queryString = "";
      const initial = params.currentOptions.length;
      let marker = new Array(initial * 2).fill("#");
      (marker[0] = "|"), (marker[initial * 2 - 1] = "|");
      let operator = new Array(initial).fill("*");
      if (
        ((operator[0] = "^"),
        (operator[initial - 1] = "$"),
        params.currentOptions.some((e) => e !== !1))
      ) {
        if (params.currentOptions.includes(!1))
          for (let i = 0; i < initial * 2; i += 2)
            params.currentOptions[i / 2] !== !1 &&
              (queryString += `[data-variants${operator[i / 2]}="${
                marker[i]
              }${CSS.escape(params.currentOptions[i / 2])}${marker[i + 1]}"]`);
        else {
          let qs = "";
          for (let i = 0; i < initial * 2; i += 2)
            qs += `${marker[i]}${CSS.escape(params.currentOptions[i / 2])}${
              marker[i + 1]
            }`;
          params.selectedVariant.isCardSwatches
            ? (queryString =
                `[data-card-product-id="${params.product.id}"][data-variants*="${qs}"]`.replace(
                  /##/g,
                  "#"
                ))
            : (queryString = `[data-variants*="${qs}"]`.replace(/##/g, "#"));
        }
        let elem = document.querySelector(queryString);
        if (elem) {
          let parent = elem.closest('[data-bstr-slide-holder]')
          let index = Array.from(parent.children).indexOf(elem)
          this.slider._moveTo({index, slider: parent})
          this.slider._moveThumbTo({index})
        }
      }
    }
    selectSwatch(params) {
      let pid = params.product.id,
        price = params.selectedVariant.price,
        variant = params.selectedVariant,
        elems = document.querySelectorAll(
          `[data-product-price="${pid}"], [data-product-price-sale="${pid}"]`
        ),
        skuElem = document.querySelector(".product-page--sku");
      skuElem && variant.sku && (skuElem.innerText = variant.sku);
      let sale = variant.sale_raw;
  
        elems.forEach((e) => {
          e &&
            typeof e.innerText == "string" &&
            (e.innerText.includes("UVP")
              ? (e.innerHTML = "UVP: <s>" + price + " \u20AC</s>")
              : (e.innerText = price)),
            sale
              ? (console.log("sale"), e.classList.add("product__price--sale"))
              : e.classList.remove("product__price--sale");
        }),
  
        document.querySelectorAll(`[data-tag-product="${pid}"]`).forEach((e) => {
          let type = sale ? e.dataset.tagType : !1;
          switch (type) {
            case "percent": {
              e.innerText =
                Math.floor(
                  ((variant.price_raw - variant.sale_raw) / variant.sale_raw) *
                    100
                ) +
                "% " +
                _bstrLocale.tags.off;
              break;
            }
            case "amount": {
              e.innerText = this.cfx.formatMoney(
                variant.sale_raw - variant.price_raw,
                this.cfx.getFormat()
              );
              break;
            }
            case "text": {
              e.innerText = _bstrLocale.tags.sale.toUpperCase();
              break;
            }
            default: {
              e.classList.add("hide");
              break;
            }
          }
          type && e.classList.remove("hide");
        }),
         document
          .querySelectorAll(`[data-product-price-sale="${pid}"]`)
          .forEach((e) => {
            if (!sale) return e.classList.add("hide");
            e.innerText.includes("UVP")
              ? (e.innerHTML = "UVP: <s>" + variant.sale + "</s>")
              : (e.innerText = variant.sale),
              e.classList.remove("hide");
          });
      let inps = document.querySelectorAll(
        `input[data-bstr-variant-input="${params.product.id}"]`
      );
      for (let input of inps)
        input.setAttribute("value", params.selectedVariant.id);
      let buttons = document.querySelectorAll(
        `[data-buy-button="${params.product.id}"]`
      );
      for (let btn of buttons)
        variant.available
          ? ((btn.querySelector("[data-button-text]").innerText =
              btn.dataset.originalText),
            btn.removeAttribute("disabled"))
          : ((btn.querySelector("[data-button-text]").innerText =
              _bstrLocale.buttons.sold_out),
            btn.setAttribute("disabled", "true"));
      let dynbuttons = document.querySelectorAll(
        `[data-dynamic-button="${params.product.id}"]`
      );
      for (let btn of dynbuttons) {
        let b = btn.querySelector("button");
        b &&
          (variant.available
            ? b.removeAttribute("disabled")
            : b.setAttribute("disabled", "true"));
      }
      if (params.selectedVariant.isCardSwatches) {
        let productHandleSelector = `[data-product-card-swatch-id='${params.product.id}']`;
        document.querySelectorAll(productHandleSelector).forEach((e) => {
          e.href = params.selectedVariant.variant_url;
        });
      } else {
        let url = new URL(document.URL);
        url.searchParams.set("variant", params.selectedVariant.id),
          history.replaceState({}, "", url);
      }
      this.events.trigger("booster:price:update", { elements: elems });
    }
    deselectSwatch(params) {
      let inps = document.querySelectorAll(
        `input[data-bstr-variant-input="${params.product.id}"]`
      );
      for (let input of inps) input.setAttribute("value", -1);
      let buttons = document.querySelectorAll(
        `[data-buy-button="${params.product.id}"]`
      );
      for (let btn of buttons)
        btn.setAttribute("disabled", "true"),
          (btn.querySelector("[data-button-text]").innerText =
            _bstrLocale.buttons.select);
      let dynbuttons = document.querySelectorAll(
        `[data-dynamic-button="${params.product.id}"]`
      );
      for (let btn of dynbuttons) {
        let b = btn.querySelector("button");
        b && b.setAttribute("disabled", "true");
      }
      let url = new URL(document.URL);
      url.searchParams.delete("variant"), history.replaceState({}, "", url);
    }
  }
  class BstrVisitor {
    constructor({ events: events2, basync, geo = !0 }) {
      (this.events = events2),
        (this.geo = geo),
        (this.basync = basync),
        (this.customer = !1),
        (this.map = {
          "%country%": { k: "country", sk: "name" },
          "%city%": { k: "city", sk: "name" },
          "%zip%": { k: "city", sk: "zip" },
          "%flag_svg%": { k: "flag", sk: "svg" },
          "%flag_emoji%": { k: "flag", sk: "emoji" },
          "%language_name%": { k: "language", sk: "name" },
          "%language_native%": { k: "language", sk: "nativeName" },
          "%language_code%": { k: "language", sk: "code" },
          "%currency_code%": { k: "currency", sk: "code" },
          "%currency_name%": { k: "currency", sk: "name" },
          "%currency_symbol%": { k: "currency", sk: "symbol" },
        }),
        this.init();
    }
    replaceContent(block) {
      let it =
        block.dataset.bstrGeoBlock == ""
          ? block.innerHTML
          : block.dataset.bstrGeoBlock;
      for (let [k, v] of Object.entries(this.map))
        it = it.replace(
          new RegExp(k, "gi"),
          v.sk ? this.customer[v.k][v.sk] : this.customer[v.k]
        );
      block.innerHTML = it;
    }
    embedGeo() {
      let gblock = document.querySelectorAll(
        "[data-bstr-geo-block]:not([data-bstr-initd])"
      );
      for (let block of gblock)
        this.replaceContent(block),
          (block.dataset.bstrInitd = "true"),
          block.removeAttribute("data-bstr-geo-block");
    }
    async init() {
      if (bstore.get("bstr:visitor_info"))
        return (
          (this.customer = bstore.get("bstr:visitor_info")),
          this.embedGeo(),
          this.events.on("booster:content:update", this.embedGeo.bind(this)),
          this.events.trigger("booster:geo:visitor", this.customer, !0)
        );
      const r = await fetch("https://js.instantgeo.info/json");
      r.ok || this.events.trigger("booster:geo:error");
      const {
          country: countryCode,
          city,
          postalCode: zip = "00000",
          ip = "0.0.0.0",
        } = r.ok ? await r.json() : { country: "US", city: "Washington, D.C." },
        sectionUrl = new URL(window.location);
      (sectionUrl.pathname = bstri18n.all_products_route),
        sectionUrl.searchParams.set("sort_by", countryCode || "US");
      const { json } = await this.basync.load({
        url: sectionUrl,
        section: "countries",
        json: "div#countries-json",
      });
      if (!json) return this.events.trigger("booster:geo:error");
      let {
        capital,
        region,
        name,
        nativeName,
        currency,
        languages,
        flag,
        emoji,
      } = json;
      const ml = languages[0];
      let languageCode = ml.iso639_1.toLowerCase();
      switch (countryCode) {
        case "BR": {
          languageCode = "pt-br";
          break;
        }
        case "PT": {
          languageCode = "pt-pt";
          break;
        }
      }
      return (
        (this.customer = {
          ip,
          country: { code: countryCode, name, nativeName, capital },
          region,
          city: {
            name: city,
            zip,
            capital: capital.toLowerCase() == city.toLowerCase(),
          },
          language: {
            code: languageCode,
            name: ml.name,
            nativeName: ml.nativeName,
          },
          currency,
          flag: {
            svg: `<img src="${flag}" style="height: 1em">`,
            emoji: emoji
              .split(" ")
              .reduce(
                (a, v) => ((a += String.fromCodePoint(parseInt(v, 16))), a),
                ""
              ),
          },
        }),
        bstore.set("bstr:visitor_info", this.customer, 180),
        this.embedGeo(),
        this.events.on("booster:content:update", this.embedGeo.bind(this)),
        this.events.trigger("booster:geo:visitor", this.customer, !0)
      );
    }
    get() {
      return this.customer;
    }
  }
  class BstrBlockLink {
    constructor() {
      this.initBlockLinks();
    }
    initBlockLinks() {
      document.querySelectorAll(".background_image--link").forEach((e) => {
        e.addEventListener("click", function () {
          let backgroundImageUrl = e.dataset.backgroundImageUrl;
          location.href = backgroundImageUrl;
        });
      });
    }
  }
  class BstrTheme {
    constructor() {
      (this.events = new BstrEvents()),
        (this.basync = new BstrAsync({ events: this.events })),
        this.initFeaturedProducts(),
        document.dispatchEvent(
          new CustomEvent("booster:initialized", {
            detail: { BoosterTheme: this },
          })
        ),
        (this.notify = new BstrNotify({ events: this.events })),
        (this.cart = new BstrCart({ events: this.events, basync: this.basync })),
        (this.lazy = new BstrLazy({ events: this.events })),
        (this.defaultSlider = new BstrSlider({ events: this.events })),
        (this.PPSlider = new ProductSlider({
          events: this.events,
          selector: "[data-bstr-ppslider]",
        })),
        (this.sectionSlider = new BstrSectionSlider({
          events: this.events,
          selector: "[data-bstr-section-slider]",
        })),
        (this.cfx = new BstrCurrency({ events: this.events })),
        (this.swatches = new BstrSwatches({
          events: this.events,
          slider: this.PPSlider,
          cfx: this.cfx,
        })),
        (this.counters = {
          cart: new BstrCntr('[data-bstr-cntr-id^="c-"]'),
          watching: new BstrCntr('[data-bstr-cntr-id^="w-"]'),
        }),
        (this.countdown = new BstrCountdown({ events: this.events })),
        (this.filters = new BstrFilters({
          events: this.events,
          basync: this.basync,
        })),
        (this.insta = BstrDummyClass),
        (this.visitor = new BstrVisitor({
          events: this.events,
          basync: this.basync,
        })),
        (this.localize = new BstrLocalize({
          events: this.events,
          cfx: this.cfx,
        })),
        (this.freeShippingBar = new BstrFreeShipping({
          events: this.events,
          cfx: this.cfx,
        })),
        (this.inlineUpsell = new BstrIU({
          events: this.events,
          cfx: this.cfx,
          swatches: this.swatches,
        })),
        (this.ELEMENTS = new BstrElements({
          events: this.events,
          basync: this.basync,
          cart: this.cart,
          cfx: this.cfx,
        })),
        (_settings.OPDynTitle.trim() != "" ||
          _settings.BPDynTitle.trim() != "") &&
          (this.dynt = new BstrDynTitle()),
        _settings.copycat && (this.copycat = new BstrCopycat()),
        _settings.gdpr && (this.gdpr = new BstrGDPR()),
        _settings.recentlyBought &&
          typeof recentlyBoughtConfig < "u" &&
          (this.recentlyBought = new BstrRecentlyBought()),
        (this.blockLink = new BstrBlockLink()),
        this.events.trigger("booster:loaded", { BoosterTheme: this });
    }
    async initFeaturedProducts() {
      try {
        let products = document.querySelectorAll("[data-featured-product]");
        for (let i = 0, maxi = products.length; i < maxi; ++i)
          this.renderFeaturedProduct(products[i]);
      } catch {}
    }
  }
  const bstore = new BstrStore(),
    BoosterTheme = new BstrTheme();
  console.info(`888888b.                              888                88888888888 888                                      
  888  "88b                             888                    888     888                                      
  888  .88P                             888                    888     888                                      
  8888888K.   .d88b.   .d88b.  .d8888b  888888 .d88b.  888d888 888     88888b.   .d88b.  88888b.d88b.   .d88b.  
  888  "Y88b d88""88b d88""88b 88K      888   d8P  Y8b 888P"   888     888 "88b d8P  Y8b 888 "888 "88b d8P  Y8b 
  888    888 888  888 888  888 "Y8888b. 888   88888888 888     888     888  888 88888888 888  888  888 88888888 
  888   d88P Y88..88P Y88..88P      X88 Y88b. Y8b.     888     888     888  888 Y8b.     888  888  888 Y8b.     
  8888888P"   "Y88P"   "Y88P"   88888P'  "Y888 "Y8888  888     888     888  888  "Y8888  888  888  888  "Y8888  `);
  //# sourceMappingURL=/s/files/1/0854/7998/1351/t/12/assets/booster.js.map?v=1730361417
  